var _defs, _defs2, _defs3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStubackimg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 750,
    height: 500
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E5E5E5"
    },
    cx: 596.542,
    cy: 438.385,
    rx: 97.333,
    ry: 10.542
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E5E5E5"
    },
    cx: 371.719,
    cy: 434.548,
    rx: 97.333,
    ry: 10.542
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E5E5E5"
    },
    cx: 162.262,
    cy: 438.385,
    rx: 97.333,
    ry: 10.542
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EDB92C"
    },
    points: "128.865,72.812 109.472,38.842 69.036,66.751 67.35,72.512 89.017,102.046  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9B7C2C"
    },
    points: "72.622,70.006 67.35,72.618 69.036,66.857  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D9D5D1"
    },
    points: "128.586,72.432 108.234,40.03 68.346,67.92 89.017,100.859  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAF1E6"
    },
    points: "128.147,72.671 108.234,41.217 68.346,69.107 89.017,102.046  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.792,
    y: 47.952,
    transform: "matrix(-0.5915 -0.8063 0.8063 -0.5915 97.5536 194.7465)",
    style: {
      fill: "#EDB92C"
    },
    width: 36.63,
    height: 49.421
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C96E12"
    },
    d: "M199.744,131.826c0,0,2.074-2.105,4.918,3.037s17.293,22.863,11.819,24.176 c-11.053-3.501-15.429-7.001-15.757-7.658C200.397,150.725,197.233,134.04,199.744,131.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M203.956,160.11c0.49-0.3,1-0.61,1.51-0.97c6.15-4.16,13.58-11.46,15.23-16.14 c0.17-0.48,0.41-1.17,0.7-2.04c0.15-0.44,0.31-0.92,0.48-1.44c1-3,2.41-7.32,3.96-12.04c0.14-0.44,0.29-0.89,0.43-1.33 c0.92-2.81,1.88-5.72,2.82-8.56c0.09-0.28,0.18-0.56,0.28-0.84c0.37-1.11,0.73-2.21,1.09-3.28c0.18-0.53,0.36-1.05,0.53-1.58 c0.87-2.6,1.69-5,2.39-7.02c0.12-0.39,0.26-0.78,0.41-1.16c0.07-0.18,0.14-0.36,0.2-0.54c0.1-0.24,0.19-0.48,0.26-0.73 c0.15-0.46,0.27-0.92,0.38-1.39c0.08-0.33,0.46-1.38,0.46-1.92c0-0.12-0.02-0.21-0.07-0.27c-0.24-0.31-1.55-0.45-1.92-0.55 c-1.85-0.52-3.69-1.05-5.53-1.57c-0.33-0.09-4.65-3.147-4.7-3.047c-2.08,4.81-11.49,26.267-16.61,34.417 c-5.91,9.4-13.89,12.1-13.89,12.1C190.136,146.46,189.366,149.73,203.956,160.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#ECBB97"
    },
    d: "M202.806,152.8c0.08,3.4,1.73,5.48,2.66,6.34c6.15-4.16,13.58-11.46,15.23-16.14 c0.17-0.48,0.41-1.17,0.7-2.04c0.15-0.44,0.31-0.92,0.48-1.44c1-3,2.41-7.32,3.96-12.04c0.14-0.44,0.28-0.89,0.43-1.33 c0.92-2.81,1.88-5.72,2.82-8.56c0.09-0.28,0.18-0.56,0.28-0.84c0.37-1.11,0.73-2.21,1.09-3.28c0.18-0.54,0.35-1.06,0.53-1.58 c0.87-2.6,1.69-5,2.39-7.02c0.14-0.4,0.28-0.79,0.41-1.16c0.07-0.18,0.14-0.36,0.2-0.54c0.09-0.25,0.18-0.5,0.26-0.73 c0.15-0.46,0.27-0.92,0.38-1.39c0.08-0.33,0.46-1.38,0.46-1.92c-1.38,0.17-3.3,0.07-5.92-0.58c2.95,1.72,3.06,1.3,3.29,2.32 c0.25,1.03-13.57,37.72-15.21,40.22C215.606,143.61,205.866,151.92,202.806,152.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C96E12"
    },
    d: "M112.259,150.317c0,0-5.42,4.706-1.839,6.4c4.864-0.551,5.425-0.141,5.425-0.551 s0.656-2.649,0.656-2.649L112.259,150.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M94.333,85.198c0.827,6.892,1.313,8.205,2.967,11.329c0.315,5.907,3.282,29.536,6.222,36.756 c2.967,7.22,12.458,23.603,12.458,23.603l2.822,1.759l0.643,0.394c0,0,0.42-0.368,1.09-1.037c0.512-0.525,1.195-1.234,1.943-2.113 c3.702-4.398,9.097-12.865,5.422-21.791c0,0-9.11-10.567-10.423-14.479c-1.313-3.899-7.22-19.651-6.235-23.918 c0.985-4.266,5.579-10.016,6.564-11.985c0.985-1.969,2.127-7.062-1.47-4.266c-2.442,2.297-7.378,7.325-10.108,9.123 c0,0-0.013,0.013-0.026,0.026c-0.394,0.249-0.735,0.433-1.024,0.538c-2.31,0.827-4.109,1.142-4.765-0.656 c-0.289-0.801-0.814-2.337-1.339-3.873c-0.656-1.917-1.339-3.807-1.615-4.175c-0.355-0.473-2.258-1.365-2.967,0.761 c0,0,0,0,0,0.013C94.202,82.021,94.11,83.295,94.333,85.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C96E12"
    },
    d: "M127.158,130.517c0,0-0.78-1.264-2.359-0.155c1.863,2.27,2.43,2.945,2.43,2.945 S127.431,131.642,127.158,130.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#ECBB97"
    },
    d: "M94.333,85.198c0.827,6.892,1.313,8.205,2.967,11.329 c0.315,5.907,3.282,29.536,6.222,36.756c2.967,7.22,12.458,23.603,12.458,23.603l2.822,1.759c0.63-0.171,1.221-0.394,1.733-0.643 c0.985-0.512,1.693-1.195,1.943-2.113c0.42-1.575-0.551-3.846-3.846-7.102c-13.495-13.324-19.205-43.569-19.468-52.325 c-4.332-3.216-4.66-14.781-4.673-15.254C94.202,82.021,94.11,83.295,94.333,85.198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#ECBB97"
    },
    d: "M99.072,84.607c0,0,0.079,5.842,2.1,6.222c1.916,0.354,4.699-1.956,5.028-2.232 c-0.394,0.249-0.735,0.433-1.024,0.538c-2.31,0.827-4.109,1.142-4.765-0.656C100.122,87.679,99.597,86.143,99.072,84.607z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A34F25"
    },
    points: "104.908,229.843 119.102,233.207 104.908,280.793 88.69,273.714  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A34F25"
    },
    d: "M104.908,280.793l11.629-7.548l13.948-43.402l-11.383,3.364 C119.102,233.207,107.074,274.448,104.908,280.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#A34F25"
    },
    d: "M104.908,280.793l11.629-7.548l13.948-43.402l-11.383,3.364 C119.102,233.207,107.074,274.448,104.908,280.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C96E12"
    },
    d: "M201.206,259.671c0,0-1.536,5.912-5.365,4.818c-3.829-1.094-4.813-6.673-4.813-6.673l1.181-4.511 l2.319-2.381C194.529,250.924,201.32,255.619,201.206,259.671z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A34F25"
    },
    points: "104.908,229.843 126.874,220.08 130.484,229.843 119.102,233.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#A34F25"
    },
    points: "104.908,229.843 126.874,220.08 130.484,229.843 119.102,233.207  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A34F25"
    },
    d: "M104.908,229.843L85.741,240.94c-2.573,1.489-2.659,5.173-0.159,6.781l10.274,6.608 L104.908,229.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#A34F25"
    },
    d: "M104.908,229.843l-19.085,11.049c-2.61,1.511-2.698,5.249-0.161,6.881l10.194,6.557 L104.908,229.843z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B7"
    },
    d: "M149.802,433.315c-0.027,0.423-0.081,0.861-0.35,1.147c-0.269,0.302-0.699,0.347-1.076,0.362 c-4.289,0.257-8.592,0.498-12.881,0.74c0.054-0.86-1.694-0.694-1.734-0.03c-8.955,0.876-18.044,0.815-27.012,0.136 c-0.538-0.045-1.17-0.166-1.358-0.725c-0.242-1.993,0.766-3.97,2.165-5.224c1.412-1.253,3.16-1.887,4.894-2.4 c4.894-1.464,10.151-2.249,14.239-5.616c0.551-0.453,2.433-0.211,2.904-0.784c0.699-0.86,1.433-3.57,1.689-4.702l1.279-4.918 c5.513,0.498,9.362-1.331,14.875-0.833c0.309,1.495,0.735,8.019,0.936,9.544C148.991,424.555,150.178,428.741,149.802,433.315z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3243"
    },
    d: "M151.451,433.288c-0.197,0.912-0.648,1.507-1.479,1.537c-4.816,0.257-9.647,0.498-14.463,0.74 c0.061-0.86-1.902-0.694-1.947-0.03c-10.055,0.876-20.26,0.815-30.33,0.136c-0.604-0.045-1.313-0.166-1.525-0.725 c-0.272-1.993,0.861-3.97,2.431-5.224c1.585-1.253,3.548-1.887,5.495-2.4c5.495-1.464,11.398-2.249,15.987-5.616 c0.225-0.165,0.386-0.317,0.548-0.48c0.677-0.68,1.674-0.896,2.592-0.614c4.176,1.282,8.607,1.714,12.955,1.301 c1.134-0.108,2.262-0.273,3.38-0.496c0.863-0.172,2.193-0.831,3.043-0.762c1.125,0.091,1.189,1.05,1.54,2.15 C150.076,424.055,152.09,430.336,151.451,433.288z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAF1E6"
    },
    d: "M117.616,425.302c0.104,1.078,0.902,1.901,1.644,2.641c1.355,1.351,3.416-0.718,2.097-2.097 c-0.734-0.767-1.524-1.548-2.609-1.677C118.179,424.102,117.563,424.745,117.616,425.302L117.616,425.302z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAF1E6"
    },
    d: "M122.046,422.994c-0.773,0.852,0.122,2.271,0.607,3.072c1.096,1.806,3.793-0.19,2.318-1.788 C124.433,423.694,122.912,422.039,122.046,422.994L122.046,422.994z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M101.707,434.946 c0,0,31.772,2.255,49.526-0.999"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B7"
    },
    d: "M177.107,433.315c0.027,0.423,0.081,0.861,0.35,1.147c0.269,0.302,0.699,0.347,1.076,0.362 c4.289,0.257,8.592,0.498,12.881,0.74c-0.054-0.86,1.694-0.694,1.734-0.03c8.955,0.876,18.044,0.815,27.012,0.136 c0.538-0.045,1.17-0.166,1.358-0.725c0.242-1.993-0.766-3.97-2.165-5.224c-1.412-1.253-3.16-1.887-4.894-2.4 c-4.894-1.464-10.151-2.249-14.239-5.616c-0.551-0.453-2.433-0.211-2.904-0.784c-0.699-0.86-1.433-3.57-1.689-4.702 l-1.279-4.918c-5.513,0.498-9.362-1.331-14.875-0.833c-0.309,1.495-0.735,8.019-0.936,9.544 C177.918,424.555,176.731,428.741,177.107,433.315z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3243"
    },
    d: "M175.458,433.288c0.197,0.912,0.648,1.507,1.479,1.537c4.816,0.257,9.647,0.498,14.463,0.74 c-0.061-0.86,1.902-0.694,1.947-0.03c10.055,0.876,20.26,0.815,30.33,0.136c0.604-0.045,1.313-0.166,1.525-0.725 c0.272-1.993-0.861-3.97-2.431-5.224c-1.585-1.253-3.548-1.887-5.495-2.4c-5.495-1.464-11.398-2.249-15.987-5.616 c-0.225-0.165-0.386-0.317-0.548-0.48c-0.677-0.68-1.674-0.896-2.592-0.614c-4.176,1.282-8.607,1.714-12.955,1.301 c-1.134-0.108-2.262-0.273-3.38-0.496c-0.863-0.172-2.193-0.831-3.043-0.762c-1.125,0.091-1.189,1.05-1.54,2.15 C176.833,424.055,174.819,430.336,175.458,433.288z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAF1E6"
    },
    d: "M209.293,425.302c-0.104,1.078-0.902,1.901-1.644,2.641c-1.355,1.351-3.416-0.718-2.097-2.097 c0.734-0.767,1.524-1.548,2.609-1.677C208.73,424.102,209.347,424.745,209.293,425.302L209.293,425.302z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAF1E6"
    },
    d: "M204.863,422.994c0.773,0.852-0.122,2.271-0.607,3.072c-1.096,1.806-3.793-0.19-2.318-1.788 C202.476,423.694,203.997,422.039,204.863,422.994L204.863,422.994z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M225.202,434.946 c0,0-31.772,2.255-49.526-0.999"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C96E12"
    },
    d: "M115.974,257.154c0,0,0.683,3.643,4.234,4.654c1.426-4.912,0.232-7.848,0.232-7.848 S118.434,253.758,115.974,257.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E283D"
    },
    d: "M119.735,276.154v2.657c0.106,28.88,8.842,80.492,8.118,133.904c14.478,2.898,22.333,0,22.333,0 l9.027-124.658l16.153,124.658c0,0,1.655,2.567,21.93,0c-1.193-70.397,1.229-114.58,0.596-134.086 c-0.226-6.899-0.362-25.618-0.362-25.618l-24.654-13.262l-14.84,7.84c0,0-0.619,0.242-1.812,0.649 c-0.075,0.045-0.136,0.061-0.211,0.091c-4.801,1.721-17.931,0.555-35.338,5.099C119.936,256.056,119.765,267.654,119.735,276.154z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C667A"
    },
    d: "M135.782,266.759c0,0,1.026,10.465-10.172,13.774C129.482,276.892,133.769,273.813,135.782,266.759 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeMiterlimit: 10
    },
    d: "M159.213,288.057c0,0,4.348-11.442,6.098-14.411"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 194.989,
    y1: 254.411,
    x2: 194.989,
    y2: 255.411
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "2.0007,2.0007"
    },
    points: " 194.989,257.412 194.989,332.439 194.989,408.467  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 194.989,
    y1: 409.468,
    x2: 194.989,
    y2: 410.468
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 121.996,
    y1: 260.425,
    x2: 122.032,
    y2: 261.425
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "1.9775,1.9775"
    },
    points: " 122.103,263.401 123.573,304.134 128.186,366.089 130.595,408.482  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 130.652,
    y1: 409.469,
    x2: 130.708,
    y2: 410.468
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E48A29"
    },
    d: "M120.29,226.93c-0.15,1.03-3.84,29.67-4.35,30.26c1.31-1.53,11.19-4.13,21.04-1.79 c9.81,2.34,15.58,3.24,35.53-1.02c1.37-0.29,2.65-0.65,3.89-0.9l1.15-0.23c9.6-1.97,15.44-1.02,18.91,0.71 c3.81,1.9,4.77,4.74,4.72,5.68c0.66-2.94-0.23-37.41-2.85-47.69c0-0.01-0.02-0.01-0.02-0.02c-2.65-10.33-5.54-20.51-5.82-22.8 c-0.57-4.6-0.74-10.07,2.33-12.7c3.06-2.62,13.56-11.26,21.66-17.39c-2.68-1.26-4.92-2.72-6.81-4.32 c-11.12-9.32-9.93-22.89-9.93-22.89s-23.62,19.88-28.26,20.21c-4.62,0.33-2.48-4.92-2.48-4.92s-15.75-4.9-15.04-0.89 c0.46,6.39-5.31,5.51-6.46,5.18c-0.12-0.04-0.24-0.09-0.36-0.14c-8.53-3.42-16.42-16.87-19.99-20.76c1,5.95-3.81,12.99-8.52,18.28 h-0.01c-4.12,4.64-8.19,7.92-8.19,7.92s4.32,3.86,10.43,8.89c11.67,9.58,8.13,25.74,4.35,39.71c-0.54,2-1.08,3.95-1.58,5.83 c-0.01,0.04-0.03,0.08-0.04,0.13c-0.55,2.05-1.05,4-1.45,5.84C121.44,220.37,120.75,223.62,120.29,226.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M158.971,144.809h0.039c0.105,0.026,0.197,0.039,0.302,0.039c0,0.013,0,0.013,0,0.013 c0,0.289,9.307,3.584,9.307,3.584c-0.289,1.536-0.236,3.82,2.862,3.597c0,0-0.512,13.56-12.484,12.747 c-2.35-0.328-6.183-3.61-9.084-8.073c-1.103-1.68-2.061-3.518-2.77-5.448c0.118,0.053,0.236,0.105,0.355,0.144 c1.155,0.328,6.918,1.208,6.459-5.185c-0.092-0.538,0.105-0.906,0.525-1.168L158.971,144.809z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#A34F25"
    },
    points: "88.69,270.714 100.292,267.291 104.908,277.793  "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A34F25"
    },
    d: "M100.292,270.291c0.481-3.358,1.475-6.604,2.334-9.869c0.886-3.261,1.874-6.491,2.867-9.719 c1.019-3.22,2.047-6.436,3.162-9.625l1.68-4.781c0.6-1.581,1.165-3.173,1.8-4.742c-0.391,1.647-0.85,3.272-1.272,4.91 l-1.379,4.875c-0.92,3.25-1.918,6.474-2.913,9.7c-1.02,3.218-2.034,6.437-3.117,9.634l-1.607,4.802 C101.307,267.075,100.704,268.66,100.292,270.291z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M147.144,151.267c0.709,1.93,1.667,3.768,2.77,5.448c1.588-3.466,18.706-8.27,18.706-8.27 s-9.307-3.295-9.307-3.584c0,0,0,0,0-0.013c0-0.026-0.118-0.039-0.302-0.039h-0.039c-0.814-0.013-2.954,0.131-4.489,0.249 c-0.42,0.263-0.617,0.63-0.525,1.168c0.459,6.393-5.303,5.514-6.459,5.185C147.38,151.372,147.262,151.32,147.144,151.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E362E"
    },
    d: "M187.178,108.517c0,0-0.713,12.854-5.525,14.731C180.928,113.406,179.902,105.299,187.178,108.517z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M142.312,127.622c0,0,1.589,12.063,4.864,14.414c9.119,6.217,16.293,7.2,21.54,6.164 c5.794-1.11,9.228-4.65,10.349-6.303c2.98-4.37,4.368-31.582,4.444-32.235c0.753-5.89-12.698-9.648-16.362-8.894 c-2.097,0.433-6.16,0.681-9.74,0.887c0,0-0.012,0.014-0.026,0.002c-2.661,0.165-5.046,0.307-6.15,0.495 c-1.389,0.239-4.587,1.954-7.697,4.675c-2.72,2.358-5.36,5.487-6.693,9.094C133.059,125.475,142.312,127.622,142.312,127.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M182.104,119.969c0,0,1.881-5.512,4.397,0.693c2.516,6.205-3.007,10.665-5.822,9.661 C179.031,123.783,182.104,119.969,182.104,119.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#ECBB97"
    },
    d: "M142.312,127.622c0,0,1.589,12.063,4.864,14.414c9.119,6.217,16.293,7.2,21.54,6.164 c-32.112-0.304-18.787-36.17-17.416-37.528c2.858,1.346,3.698,0.706,4.159-0.362c2.82,2.126,10.039,1.802,14.043,0.571 c6.377,4.387,11.315,0.558,12.816-1.115c0.769,0.052,1.19-0.104,1.19-0.104c0.753-5.89-12.698-9.648-16.362-8.894 c-2.097,0.433-6.16,0.681-9.74,0.887c0,0-0.012,0.014-0.026,0.002c-3.341,0.831-10.784,3.876-13.847,5.171 c-2.72,2.358-5.36,5.487-6.693,9.094C133.059,125.475,142.312,127.622,142.312,127.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E362E"
    },
    d: "M135.699,120.528c0,0,0.748-5.336,3.931-5.402c3.171-0.052,3.853,1.431,4.933,7.477 c-0.047-9.325,6.369-12.518,6.729-13.538c1.977,1.37,3.73,1.217,2.848-1.341c3.899,3.166,11.504,3.493,14.727,1.46 c4.601,3.658,10.69,2.918,13.011-0.697c5.133,0.99,11.288-0.204,11.088-8.87c-0.212-8.652-6.951-7.96-6.951-7.96 s0.366-3.972-1.775-6.777c-0.506-0.667-1.165-1.269-1.996-1.737c-4.321-2.418-10.235-2.233-12.865-0.357 c-7.928-5.398-15.325-2.884-19.65-0.346l-0.012,0.014c-2.445,1.425-3.901,2.869-3.901,2.869s-0.814-1.181-1.601-1.442 c-2.408-0.568-0.635,3.455-0.635,3.455s-1.422-0.588-2.539-0.715c-1.105-0.128-2.816,0.956-0.531,2.075 c-8.49,0.857-11.153,8.112-11.268,16.792C129.112,114.183,135.699,120.528,135.699,120.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#332D27"
    },
    d: "M135.699,120.528c0,0,0.748-5.336,3.931-5.402c3.171-0.052,3.853,1.431,4.933,7.477 c-0.047-9.325,6.369-12.518,6.729-13.538c1.977,1.37,3.73,1.217,2.848-1.341c3.899,3.166,11.504,3.493,14.727,1.46 c4.601,3.658,10.69,2.918,13.011-0.697c5.133,0.99,11.288-0.204,11.088-8.87c-0.212-8.652-6.951-7.96-6.951-7.96 s-4.58,12.482-17.73,5.218c-5.742,2.16-11.297,5.252-15.173,0.081c-6.989,0.7-14.167-1.087-12.604-8.259 c-8.49,0.857-11.153,8.112-11.268,16.792C129.112,114.183,135.699,120.528,135.699,120.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#3E362E"
    },
    d: "M154.934,90.947c0.824,3.868,8.673,3.212,12.872,0.435 c19.926,7.754,16.434-6.489,16.434-6.489s0,0-0.001-0.013c-0.506-0.667-1.165-1.269-1.996-1.737 c-4.321-2.418-10.235-2.233-12.865-0.357c-7.928-5.398-15.325-2.884-19.65-0.346l-0.012,0.014 C145.178,89.371,152.078,90.378,154.934,90.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M182.783,120.217c0,0,2.094-1.296,2.178,1.944c0.084,3.24-3.062,6.204-3.062,6.204L182.783,120.217 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M141.648,119.117l0.47,5.405c0,0-2.461-0.842-3.379-2.869 C137.821,119.625,140.318,117.081,141.648,119.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#C96E12"
    },
    d: "M120.29,226.93c-0.15,1.03-3.84,29.67-4.35,30.26c1.31-1.53,11.19-4.13,21.04-1.79 c9.81,2.34,15.58,3.24,35.53-1.02c1.37-0.29,2.65-0.65,3.89-0.9l1.15-0.23c9.6-1.97,15.44-1.02,18.91,0.71 c-3.071-5.146-13.983-7.743-19.367-9.448c-9.124-2.891-17.219-3.593-24.873-10.185c-14.569-12.547-22.647-38.294-17.57-56.687 c4.16-15.1-16.02-28.85-16.03-28.85c-4.12,4.64-8.19,7.92-8.19,7.92s4.32,3.86,10.43,8.89c11.67,9.58,8.13,25.74,4.35,39.71 c-0.53,2-1.03,3.94-1.58,5.83c-0.01,0.04-0.03,0.08-0.04,0.13c-0.55,2.05-1.05,4-1.45,5.84 C121.44,220.37,120.75,223.62,120.29,226.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#C96E12"
    },
    d: "M192.485,189.126c-0.564-4.594-0.735-10.069,2.337-12.694 c3.059-2.625,13.56-11.263,21.66-17.393c-2.678-1.26-4.923-2.717-6.813-4.319c0,0-17.42,10.003-20.728,17.223 c-3.308,7.22-1.785,22.211,9.373,39.985C195.662,201.597,192.774,191.423,192.485,189.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#3E362E"
    },
    d: "M180.445,147.516c0,0,5.091,19.433-26.543,44.341 c-8.76,7.22-23.418,18.87-33.284,31.993c1.18-4.709,1.169-6.723,1.169-6.723s10.618-12.769,18.706-18.542 c11.979-8.551,26.254-21.168,29.7-27.567c3.446-6.399,8.69-22.231,8.69-22.231L180.445,147.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A34F25"
    },
    d: "M174.657,151.267c0,0-4.767,17.664-29.721,33.721c-24.954,16.057-35.948,28.856-38.738,46.578 c4.594,0.984,4.594,0.984,4.594,0.984s-0.328-16.737,30.521-37.248c30.849-20.511,38.579-37.914,39.131-47.787 C178.536,146.176,174.526,148.911,174.657,151.267z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M224.638,78.213c-0.114-0.25-0.246-0.483-0.406-0.692c-0.248-0.325-0.58-0.588-0.972-0.568 c-0.532,0.028-1.04,0.582-1.301,1.206c-0.261,0.623-0.325,1.306-0.379,1.968c-0.226,2.781-0.355,5.574-0.065,8.243 c0.29,2.669,1.019,5.225,2.372,7.153c2.977,4.24,10.637,6.508,14.76,0.611c1.435-2.052,2.058-4.772,3.578-6.73 c1.609-2.071,4.117-3.162,5.1-5.699c0.274-0.707,0.324-1.679-0.202-1.929c-0.275-0.131-0.612-0.009-0.921,0.122 c-1.952,0.825-3.847,2.013-5.596,3.505c0.956-3.123,3.579-5.215,5.044-8.107c0.229-0.451,0.435-0.958,0.399-1.442 c-0.058-0.766-0.732-1.168-1.372-1.057c-0.639,0.111-1.239,0.6-1.795,1.097c-1.951,1.745-3.737,3.778-5.517,5.803 c1.357-3.109,2.714-6.219,4.071-9.328c0.367-0.842,0.742-1.862,0.405-2.584c-0.298-0.638-1.062-0.72-1.685-0.396 c-0.623,0.324-1.134,0.957-1.612,1.579c-2.136,2.782-4.088,5.776-5.821,8.928c-0.003-3.46,2.399-6.85,2.511-10.33 c0.014-0.447-0.014-0.906-0.198-1.253c-1.021-1.934-3.977,3.394-4.564,4.494c-1.339,2.513-2.318,5.241-3.263,7.945 c-0.226,0.645-0.683,1.454-1.174,1.275c-0.215-0.078-0.334-0.335-0.424-0.584C225.237,80.403,225.08,79.184,224.638,78.213z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5B592"
    },
    d: "M229.616,85.271c3.332,0.762,6.169,2.309,8.928,4.274c0.135,0.096,0.303-0.121,0.178-0.231 c-2.552-2.244-5.759-3.554-9.06-4.212C229.553,85.08,229.505,85.246,229.616,85.271L229.616,85.271z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5B592"
    },
    d: "M238.306,90.216c-2.642,0.298-5.038,3.156-5.561,5.666c-0.036,0.175,0.199,0.233,0.263,0.073 c0.935-2.332,2.513-5.135,5.298-5.466C238.478,90.469,238.481,90.197,238.306,90.216L238.306,90.216z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5B592"
    },
    d: "M225.759,87.091c2.334,1.957,2.77,4.45,2.313,7.333c-0.033,0.206,0.232,0.278,0.31,0.086 c1.119-2.768-0.235-5.871-2.487-7.594C225.794,86.839,225.662,87.01,225.759,87.091L225.759,87.091z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D1D19"
    },
    d: "M175.818,122.068c0.226,1.631,1.1,2.557,2.003,2.432c0.903-0.125,1.492-1.255,1.266-2.885 c-0.226-1.631-1.079-2.407-1.982-2.282C176.202,119.458,175.592,120.438,175.818,122.068z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D1D19"
    },
    d: "M152.616,117.342c1.829-3.457,5.605-3.832,8.82-2.072c0.914,0.5,1.461-0.704,0.559-1.198 c-3.888-2.128-8.656-1.626-10.877,2.572C150.712,117.412,152.206,118.117,152.616,117.342L152.616,117.342z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D1D19"
    },
    d: "M174.482,115.231c2-2.103,4.786-1.754,6.79,0.176c0.575,0.554,1.826,0.057,1.124-0.619 c-2.581-2.487-6.395-3.292-9.09-0.457C172.729,114.937,173.953,115.787,174.482,115.231L174.482,115.231z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D1D19"
    },
    d: "M157.037,123.02c0.231,1.669,1.126,2.617,2.049,2.489c0.924-0.128,1.527-1.284,1.295-2.952 c-0.231-1.668-1.104-2.463-2.028-2.335C157.43,120.35,156.806,121.352,157.037,123.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F4EB"
    },
    d: "M167.657,140.77c-2.564-0.087-6.188-3.534-4.965-6.184c0.116-0.252,0.276-0.499,0.517-0.637 c0.292-0.167,0.651-0.146,0.986-0.121c1.29,0.097,2.585,0.219,3.877,0.263c3.485,0.118,5.631-0.172,5.58,1.324 C173.603,136.91,171.143,140.888,167.657,140.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M157.859,128.197c-0.031,1.285-2.141,2.276-4.713,2.214c-2.572-0.062-4.632-1.154-4.601-2.438 c0.031-1.285,2.141-2.276,4.713-2.214C155.83,125.82,157.89,126.912,157.859,128.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M182.206,129.119c-0.215,1.267-2.445,1.946-4.982,1.516c-2.537-0.43-4.419-1.806-4.204-3.073 c0.215-1.267,2.445-1.946,4.982-1.516C180.538,126.476,182.42,127.852,182.206,129.119z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5AC8A"
    },
    d: "M168.385,122.499c0.161,0.59,0.309,1.139,0.534,1.663c0.224,0.521,0.467,1.021,0.76,1.496 c0.299,0.47,0.599,0.94,0.954,1.374c0.332,0.443,0.723,0.874,1.088,1.255l0.481,0.503l-0.56,0.275 c-0.483,0.237-0.987,0.485-1.468,0.748c-0.237,0.137-0.481,0.269-0.7,0.427c-0.212,0.162-0.451,0.313-0.524,0.598 c-0.083-0.299,0.099-0.613,0.26-0.854c0.173-0.251,0.376-0.47,0.59-0.673c0.429-0.41,0.886-0.762,1.392-1.077l-0.079,0.778 c-0.517-0.399-0.918-0.844-1.314-1.325c-0.37-0.493-0.715-1.013-0.967-1.581c-0.272-0.557-0.441-1.168-0.533-1.779 C168.197,123.716,168.248,123.084,168.385,122.499z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E48A29"
    },
    d: "M144.748,140.032c5.698,5.284,15.248,9.424,23.124,8.526c9.98-1.695,14.005-10.097,15.442-18.682 c-2.465-1.513-11.889-6.306-29.339-3.826c-3.979,0.92-5.797,1.394-5.797,1.394L144.748,140.032z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M144.748,140.032c6.424,5.602,15.248,9.424,23.124,8.526c9.98-1.695,14.005-10.097,15.442-18.682 c-2.465-1.513-11.889-6.306-29.339-3.826c-3.979,0.92-5.797,1.394-5.797,1.394L144.748,140.032z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152265716034766447140000008116881151804822425_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152265716034766447140000008116881151804822425_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M153.598,146.581c3.124,0,3.129-4.855,0-4.855 C150.474,141.726,150.469,146.581,153.598,146.581L153.598,146.581z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152265716034766447140000008116881151804822425_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M170.171,143.907c3.124,0,3.129-4.855,0-4.855 C167.047,139.052,167.042,143.907,170.171,143.907L170.171,143.907z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152265716034766447140000008116881151804822425_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M159.576,128.069c3.124,0,3.129-4.855,0-4.855 C156.452,123.214,156.447,128.069,159.576,128.069L159.576,128.069z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152265716034766447140000008116881151804822425_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M167.677,135.337c3.124,0,3.129-4.855,0-4.855 C164.553,130.482,164.548,135.337,167.677,135.337L167.677,135.337z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152265716034766447140000008116881151804822425_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M179.185,134.485c3.124,0,3.129-4.855,0-4.855C176.061,129.63,176.056,134.485,179.185,134.485 L179.185,134.485z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152265716034766447140000008116881151804822425_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M152.151,134.222c3.124,0,3.129-4.855,0-4.855 C149.027,129.367,149.022,134.222,152.151,134.222L152.151,134.222z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152265716034766447140000008116881151804822425_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M160.651,141.222c3.124,0,3.129-4.855,0-4.855 C157.527,136.367,157.521,141.222,160.651,141.222L160.651,141.222z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152265716034766447140000008116881151804822425_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M165.165,150.995c3.124,0,3.129-4.855,0-4.855C162.041,146.14,162.036,150.995,165.165,150.995 L165.165,150.995z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152265716034766447140000008116881151804822425_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M178.855,144.32c3.124,0,3.129-4.855,0-4.855C175.731,139.465,175.726,144.32,178.855,144.32 L178.855,144.32z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.92,
      fill: "#E48A29"
    },
    d: "M148.218,129.91c0,0-3.952-5.505-4.731-10.211c-0.212-1.283-0.631-2.48-0.765-3.472 c2.545-0.247,4.858,9.056,9.289,12.319c-3.027,0.513-3.043-0.12-3.043-0.12"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.92,
      fill: "#E48A29"
    },
    d: "M144.911,140.038c-0.166-0.141-0.78-1.177-0.86-1.285 c-0.799-1.065-1.379-2.377-1.792-3.368c-1.561-3.746-1.818-5.627-2.415-9.312c0,0,2.251,1.525,2.99,1.243 c0.213,6.242,3.503,9.718,3.503,9.718S144.916,140.027,144.911,140.038z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AA331B"
    },
    points: "421.474,274.361 450.651,298.685 448.469,266.294 419.291,241.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AA331B"
    },
    points: "426.705,269.974 455.882,294.299 453.699,261.908 424.522,237.583  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FDFBE5"
    },
    points: "419.291,241.969 425.15,246.855 448.366,266.209 448.469,266.299 450.652,298.69  451.776,297.751 452.287,297.317 453.402,296.388 453.912,295.954 455.016,295.027 455.528,294.604 455.885,294.299  453.702,261.907 453.599,261.817 424.525,237.588 423.983,238.035 423.575,238.386 422.419,239.35 422,239.702 420.732,240.759  420.313,241.111  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#AA331B"
    },
    points: "420.313,241.111 420.733,240.759 449.869,264.949 450.093,264.764  451.077,263.935 421.944,239.758 422.419,239.35 451.556,263.537 451.719,263.402 452.648,262.619 423.519,238.442  423.983,238.035 453.13,262.213 453.599,261.817 453.702,261.907 453.714,262.079 453.356,262.374 455.528,294.604  454.96,295.083 452.789,262.863 451.685,263.78 451.685,263.78 453.856,296.01 453.402,296.388 451.23,264.158 451.23,264.158  450.115,265.087 450.115,265.087 452.287,297.317 451.72,297.807 449.548,265.568 448.48,266.46 448.469,266.299  448.366,266.209 449.452,265.296  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M403.866,185.512c0.333,1.91,0.564,3.076,0.564,3.076s6.653,13.049,9.806,21.663 c1.859,8.549,14.959,31.276,18.086,37.159c0.051,0.808-0.359,4.204-0.538,8.716c-0.038,1,0,1.692,0.103,2.166v0.013 c0.359,1.641,1.448,0.474,2.256-0.577c1.025-1.359,1.82-6.268,4.192-6.858c1.897-0.461,5.063,2.743,9.139,5.999 c0.641-4.743-5.038-8.678-6.486-11.113c-1.692-9.306-16.394-46.324-17.138-47.721c-0.73-1.384-6.101-21.419-8.421-34.429 c-1.487-8.357-5.204-11.062-7.665-11.934c-1.384-0.487-2.371-0.397-2.371-0.397c-0.897,0.038-1.602,0.513-2.166,1.333 C399.572,157.941,402.546,177.809,403.866,185.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#ECBB97"
    },
    d: "M404.049,186.545c0.148,0.826,0.263,1.432,0.326,1.762 c0.037,0.192,0.095,0.36,0.183,0.535c0.932,1.844,6.725,13.386,9.635,21.292c0.029,0.08,0.051,0.155,0.07,0.238 c1.904,8.422,14.295,30.049,17.804,36.562c0.183,0.339,0.265,0.711,0.245,1.095c-0.07,1.361-0.379,4.343-0.528,8.098 c-0.038,1,0,1.692,0.103,2.166v0.013h0.013c0.106-5.595,1.912-7.38,2.418-9.235c0.18-0.66-0.024-1.352-0.467-1.872 c-9.052-10.629-16.15-39.465-19.563-43.856c-2.775-3.584-2.801-14.131-2.7-18.227c0.024-0.979-0.631-1.839-1.581-2.081 c-1.146-0.291-2.523-0.624-2.834-0.624c-0.265,0-1.423,1.077-2.584,2.312C404.132,185.208,403.931,185.889,404.049,186.545z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M420,428.115c-0.373,0.173-0.74,0.359-1.1,0.557c-2.029,1.134-4.092,2.444-6.322,2.483 c-1.844,0.021-3.739-0.722-5.523-1.907c-1.64-1.053-3.182-2.465-4.514-3.947c0.827,0.043,1.57-0.392,2.13-1.807 c0.805-2.066,1.961-3.919,2.753-4.397c-2.273-2.62-4.271-6.027-4.289-8.506c-0.022-2.458,0.374-31.291,0.683-53.995 c0.115-8.447,0.217-16.895,0.36-25.342c0.158-9.332,1.586-18.316,0.552-27.713c-0.214-1.949-0.644-4.143-2.303-5.188 c-1.434-0.904-3.284-0.619-4.949-0.304c-4.16,0.789-8.321,1.578-12.481,2.367c-2.533,0.48-5.427,1.228-6.522,3.562 c-0.681,1.451-0.458,3.145-0.221,4.731c1.233,8.234,1.914,16.814,4.077,24.82c3.673,13.595,1.163,28.463,3.532,42.402 c1.686,9.922,3.749,19.768,5.765,29.626c0.794,3.906-0.267,9.99-1.018,12.56c-0.071,0.245-0.147,0.456-0.209,0.638 c-0.706,1.926-2.478,7.536-2.91,11.283c-0.022,0.147-0.034,0.286-0.046,0.425c-0.304,3.472,2.88,3.953,5.137,4.073 c2.264,0.132,2.612,0.073,3.249-2.785c0.517,0.951,7.49,4.368,8.457,5.153c0.961,0.773,11.899,1.726,15.551-0.964 C423.477,433.3,421.946,429.437,420,428.115z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M389.945,430.037c0.432-3.747,2.204-9.357,2.91-11.283c0.062-0.182,0.137-0.393,0.209-0.638 c0.751-2.57,1.812-8.654,1.018-12.56c-2.015-9.858-4.078-19.704-5.765-29.626c-2.369-13.939,0.141-28.807-3.532-42.402 c-2.163-8.006-2.844-16.586-4.077-24.82c-0.1-0.67-0.194-1.359-0.222-2.041h-2.452c0.028,0.682,0.121,1.371,0.222,2.041 c1.233,8.234,1.914,16.814,4.077,24.82c3.673,13.595,1.163,28.463,3.532,42.402c1.686,9.922,3.749,19.768,5.765,29.626 c0.794,3.906-0.267,9.99-1.018,12.56c-0.071,0.245-0.147,0.456-0.209,0.638c-0.706,1.926-2.478,7.536-2.91,11.283 c-0.022,0.147-0.034,0.286-0.046,0.425c-0.304,3.472,2.88,3.953,5.137,4.073c0.799,0.047,1.356,0.067,1.775-0.049 c-2.164-0.193-4.735-0.887-4.46-4.024C389.911,430.323,389.923,430.184,389.945,430.037z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAF1E6"
    },
    d: "M415.183,424.685l0.007,0.012c-0.23,2.748-2.01,4.168-2.65,4.748 c-0.857,0.778-4.593-0.815-3.858-2.821c0.383-1.043,1.445-2.798,2.346-4.286c0.246,0.156,0.481,0.267,0.699,0.373 C412.907,423.241,414.079,423.944,415.183,424.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E283D"
    },
    d: "M419.841,435.939c-3.652,2.69-14.59,1.736-15.551,0.964c-0.968-0.785-7.94-4.202-8.457-5.153 c-0.638,2.858-0.985,2.918-3.249,2.785c-2.257-0.12-5.442-0.601-5.137-4.073c0.012-0.139,0.024-0.278,0.046-0.425 c0.432-3.747,2.204-9.357,2.91-11.283c0.062-0.182,0.137-0.393,0.209-0.638c0,0,9.435,6.279,10.729,6.858 c0.413,0.196,0.813,0.312,1.201,0.328c0.827,0.043,1.57-0.392,2.13-1.807c0.805-2.066,1.961-3.919,2.753-4.397l0.01-0.008 c0.511,0.59,1.034,1.15,1.568,1.647c0.699,0.667,1.39,1.212,2.026,1.603c-0.901,1.488-1.963,3.243-2.346,4.286 c-0.278,0.752,0.063,1.432,0.653,1.954c0.894,0.811,2.368,1.236,3.051,0.962c0.057-0.03,0.103-0.052,0.153-0.095 c0.137-0.098,0.455-0.372,0.85-0.802c0.534-0.604,1.199-1.504,1.556-2.674c0.029-0.135,0.075-0.266,0.104-0.401 c0.068-0.278,0.112-0.573,0.14-0.872c1.855,1.235,3.524,2.557,4.756,3.372c0.024,0.016,0.04,0.02,0.054,0.045 C421.946,429.437,423.477,433.3,419.841,435.939z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M339.526,431.551c-0.41-0.039-0.82-0.063-1.231-0.073c-2.323-0.043-4.767,0.049-6.712-1.04 c-1.604-0.911-2.866-2.507-3.81-4.431c-0.885-1.736-1.506-3.732-1.91-5.684c0.693,0.454,1.553,0.453,2.75-0.488 c1.737-1.379,3.668-2.397,4.593-2.41c-0.642-3.409-0.652-7.358,0.581-9.508c1.22-2.134,16.091-26.84,27.799-46.297 c5.092-8.456,11.384-16.523,16.029-25.21c2.324-4.348,0.931-9.368,0.468-14.024c-0.562-5.652-1.125-11.305-1.687-16.957 c-0.178-1.786-0.379-3.645-1.335-5.165c-1.693-2.693-4.157-1.812-6.757-1.785c-2.642,0.028-5.285,0.056-7.927,0.084 c-1.117,0.012-2.291,0.038-3.26,0.596c-1.386,0.799-1.989,2.46-2.408,4.004c-1.219,4.489-1.775,9.154-1.667,13.804 c0.103,4.439,2.009,9.134,1.716,13.423c-0.493,7.2-4.77,13.114-8.682,18.883c-4.149,6.118-6.818,12.277-9.43,19.173 c-3.669,9.689-6.93,19.516-10.261,29.323c-1.282,3.774-5.264,8.494-7.208,10.336c-0.185,0.175-0.356,0.32-0.502,0.446 c-1.581,1.308-5.938,5.261-8.199,8.279c-0.093,0.116-0.174,0.23-0.254,0.344c-2.012,2.845,0.496,4.866,2.385,6.107 c1.889,1.255,2.219,1.379,4.21-0.769c-0.032,1.082,4.268,7.547,4.709,8.713c0.441,1.152,9.408,7.487,13.918,7.003 C339.916,437.781,340.541,433.674,339.526,431.551z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M357,307.843v-8.599c-1.297,0.825-1.882,2.424-2.289,3.92c-1.219,4.489-1.775,9.154-1.667,13.804 c0.103,4.439,2.009,9.134,1.716,13.423c-0.493,7.2-4.77,13.114-8.682,18.883c-4.149,6.118-6.818,12.277-9.43,19.173 c-3.669,9.689-6.93,19.516-10.261,29.323c-1.282,3.774-5.264,8.494-7.208,10.336c-0.185,0.175-0.356,0.32-0.502,0.446 c-1.581,1.308-5.938,5.261-8.199,8.279c-0.093,0.116-0.174,0.23-0.254,0.344c-2.012,2.845,0.496,4.866,2.385,6.107 c1.593,1.059,2.087,1.294,3.395,0.059c-0.032-0.021-0.057-0.036-0.091-0.059c-1.889-1.241-4.397-3.261-2.385-6.107 c0.081-0.114,0.161-0.228,0.254-0.344c2.261-3.018,6.618-6.971,8.199-8.279c0.145-0.126,0.317-0.27,0.502-0.446 c1.943-1.842,5.925-6.562,7.208-10.336c3.332-9.807,6.592-19.634,10.261-29.323c2.612-6.897,5.281-13.055,9.43-19.173 c3.912-5.769,8.189-11.683,8.682-18.883c0.293-4.289-1.613-8.984-1.716-13.423C356.278,313.915,356.499,310.856,357,307.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M324.832,431.226c-0.44-1.166-4.741-7.631-4.709-8.713c-1.294,1.396-1.891,1.821-2.666,1.611 c1.207,2.324,3.738,6.222,4.07,7.102c0.441,1.152,9.408,7.487,13.918,7.003c0.386-0.039,0.734-0.113,1.064-0.203 C331.785,436.951,325.208,432.208,324.832,431.226z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAF1E6"
    },
    d: "M337.093,426.162l0,0.014c-1.583,2.257-3.837,2.588-4.681,2.766 c-1.132,0.24-3.557-3.018-1.91-4.381c0.856-0.708,2.658-1.689,4.186-2.52c0.133,0.259,0.281,0.473,0.416,0.674 C335.855,423.768,336.513,424.965,337.093,426.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E283D"
    },
    d: "M335.446,438.229c-4.51,0.483-13.477-5.852-13.918-7.003c-0.44-1.166-4.741-7.631-4.709-8.713 c-1.991,2.148-2.321,2.024-4.21,0.769c-1.889-1.241-4.397-3.261-2.385-6.107c0.08-0.114,0.161-0.228,0.254-0.344 c2.261-3.018,6.618-6.971,8.199-8.279c0.145-0.126,0.317-0.27,0.502-0.446c0,0,4.986,10.177,5.812,11.329 c0.258,0.378,0.545,0.679,0.872,0.889c0.693,0.454,1.553,0.453,2.75-0.488c1.737-1.379,3.668-2.397,4.593-2.41l0.013-0.002 c0.144,0.767,0.314,1.514,0.524,2.212c0.267,0.928,0.59,1.747,0.942,2.405c-1.528,0.831-3.33,1.812-4.186,2.52 c-0.619,0.51-0.667,1.269-0.42,2.017c0.364,1.151,1.422,2.261,2.151,2.369c0.064,0.002,0.115,0.007,0.18-0.005 c0.168-0.016,0.581-0.092,1.138-0.264c0.765-0.253,1.793-0.695,2.692-1.525c0.093-0.102,0.199-0.192,0.292-0.294 c0.199-0.206,0.386-0.439,0.56-0.683c0.98,2.002,1.755,3.984,2.409,5.309c0.012,0.026,0.025,0.038,0.024,0.066 C340.541,433.674,339.916,437.781,335.446,438.229z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3243"
    },
    d: "M430.09,310.33c-0.08,0.07-0.17,0.14-0.27,0.21c-1.74,1.25-5.09,0.73-7.08,0.73h-0.04 c-18.68,0.88-37.61,7.11-56.63,6.71c-11.09-0.23-21.88-2.75-31.88-6.51c-4.76-1.78-9.11-4.31-14.1-5.49 c-2.95-0.72-5.89-1.43-8.83-2.15c-2.19-0.54-3.7-2.33-3.7-4.38c0.02-11.06,4.63-21.86,9.97-31.92 c8.22-15.46,18.37-30.1,30.19-43.55c2.15-2.45,4.36-4.86,6.4-7.39c1.31-1.62,2.95-2.92,4.48-4.36l0.01-0.01 c0.6-0.56,1.18-1.14,1.71-1.77c1.01-1.18,1.15-1.81,2.61-1.89c1.52-0.07,3.49,0.74,5.01,0.99c3.36,0.54,6.75,0.86,10.15,0.96 c1.98,0.06,3.96,0.04,5.93-0.06c4.7-0.09,9.7-0.63,14.51-1.92c0.07,0.58-0.17,0.95-0.36,1.49c-0.26,0.71,0.32,1.87,0.48,2.6 c0.11,0.52,0.25,1.03,0.41,1.53c1.83,6.09,6.3,11.28,9.47,16.83c8.38,14.69,14.84,30.3,18.75,46.45c1.95,8,3.26,16.13,3.85,24.31 C431.3,304.11,432.3,308.37,430.09,310.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232937"
    },
    d: "M353.609,252.073c0,0,0.541,15.042-17.653,44.255C342.507,282.12,349.662,267.953,353.609,252.073z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232937"
    },
    d: "M405.133,255.852c0,0,8.205,10.658,7.649,40.06C411.084,282.652,409.924,269.148,405.133,255.852z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232937"
    },
    d: "M385.737,247.299c0,0,5.131,15.97-3.305,54.665C384.338,284.062,386.834,265.962,385.737,247.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E48A29"
    },
    d: "M409.211,145.361c1.133,2.618,1.968,5.369,1.406,8.113c-0.541,2.638-2.301,4.835-4.007,6.92 c-2.9,3.544-5.8,7.089-8.7,10.633c-1.481,1.81-3.137,3.568-4.484,5.479c-1.193,1.693-1.941,3.733-2.837,5.624 c-4.04,8.53-9.38,17.4-16.48,23.72c-4.3,3.84-9.74,6.13-15.5,6.37c-6.11,0.25-11.26-1.84-16.46-4.7 c-2.04-1.12-3.27-2.35-5.49-3.15c-2.66-0.95-5.29-1.94-7.7-3.43c-3.21-1.98-6.02-4.87-7.15-8.47c-1.25-3.99-0.33-8.29-0.36-12.47 c-0.04-4.48-1.2-8.85-2.79-13.01c-1.05-2.77-1.12-7.02-0.8-10.47c0.07-0.69,0.15-1.35,0.24-1.96c1.16-7.59,4.83-11.38,10.36-15.99 c4.82-4.01,10.74-9.1,11.93-15.62c1.27-6.94,1.23-14.27,3.49-21.13c2.41-7.33,6.83-14.2,12.99-18.92 c15.322-11.75,40.066-6.931,44.474,13.469c0.784,3.627,0.796,7.386,0.286,11.051c-0.6,4.31-1.56,8.14-1.43,12.39 c0.321,7.915,4.561,16.193,7.941,23.234C408.504,143.802,408.871,144.575,409.211,145.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#E48A29"
    },
    d: "M408.06,146.18c-0.11,0.12-0.34,0.35-0.71,0.64l0.15,0.04 c0.08,0.08,0.16,0.16,0.25,0.23c-0.84,1.91-2.86,4.84-3.4,5.98c-1.5,3.16-3,6.33-4.5,9.5c-3.08,6.52-6.17,13.04-9.26,19.56 c-4.04,8.53-9.38,17.4-16.48,23.72c-4.3,3.84-9.75,6.14-15.51,6.38c-6.11,0.25-11.25-1.85-16.45-4.71 c-2.04-1.12-3.27-2.35-5.49-3.15c-2.66-0.95-5.29-1.94-7.7-3.43c-3.21-1.98-6.02-4.87-7.15-8.47c-1.25-3.99-0.33-8.29-0.36-12.47 c-0.04-4.48-1.2-8.85-2.79-13.01c-1.05-2.77-1.12-7.02-0.8-10.47c1.74-2.13,3.78-3.96,5.97-5.62c4.63-3.52,9.92-6.31,14.59-9.65 c3.97-2.83,6.81-5.96,9.61-9.88c0.09-0.12,0.17-0.24,0.26-0.36c2.85-3.99,5.69-7.53,6.78-12.55c15.63-0.36,16.44,0.56,16.99,0.39 c0.56-0.15,26.06,0.05,26.94,0.05c0,0,0.46,0.3,1.2,0.91c0.03,0.74,0.09,1.5,0.18,2.27c0.66,5.22,2.56,9.59,5.3,13.96 c0.28,0.44,0.53,0.92,0.73,1.43c0.81,2.52,1.3,5.5,1.56,7.21c0.01,0.12,0.03,0.23,0.04,0.33c0.01,0.11,0.03,0.21,0.04,0.31 c0.02,0.16,0.03,0.29,0.05,0.4c0.01,0.04,0.01,0.09,0.01,0.12c0.02,0.16,0.03,0.25,0.03,0.25S408.11,146.12,408.06,146.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#E48A29"
    },
    d: "M336.52,127.02c2.46-0.38,4.86-1.14,7.1-2.22c3.77-1.82,6.3-5.9,8.52-9.34 c-0.55,0.81-0.75,2.43-1.15,3.37c-1.13,2.65-2.63,5.09-4.36,7.38c-0.49,0.65-0.98,1.15-1.48,1.54c-1.41,1.1-2.98,1.3-5.32,1.33 c-1.42,0.03-2.84-0.09-4.23-0.35L336.52,127.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA331B"
    },
    d: "M355.931,158.643c0,0-6.076,14.924-11.041,29.006c-6.112,17.333-10.158,24.023-24.235,31.181 c2.773,3.025,4.388,2.916,4.388,2.916s16.477-9.064,24.152-34.602c7.675-25.538,9.935-24.88,9.935-24.88L355.931,158.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M398.139,111.796c0,0,1.049-5.729,4.451,0.038s-1.405,10.992-4.336,10.413 C395.661,116.02,398.139,111.796,398.139,111.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M398.848,111.941c0,0,1.88-1.59,2.441,1.602c0.56,3.192-2.115,6.587-2.115,6.587L398.848,111.941z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#E48A29"
    },
    d: "M418.205,164.399c-0.182-3.409-2.515-6.5-6.698-13.062 c-7.86-14.676-15.868-7.418-15.909-7.381c0,0-0.001-0.002-0.001-0.002l-2.15,0.53l-1.2,0.29l-7.665-0.288 c0,0,3.667,1.656,4.059,3.449c3.192,14.581-18.152,20.517-22.897,6.365c-0.03-0.088-0.059-0.177-0.088-0.266 c-0.35-1.06-0.68-2.11-0.84-3.21c-0.12-0.99-0.33-1.97-0.69-2.91c-0.05-0.11-0.09-0.21-0.15-0.33c0-0.02,0-0.03-0.02-0.05 c-0.05,0-0.89,0.24-0.94,0.26c-0.32,0.1-0.67,0.19-1,0.24c-0.08,0.02-0.08,0.02-0.08,0.02s-0.84,0.12-2.04,0.06 c-0.29-0.02-0.6-0.05-0.92-0.09c-0.23-0.03-0.47-0.08-0.72-0.13c-0.58-0.12-1.19-0.29-1.79-0.54c-0.68-0.29-1.36-0.67-1.97-1.2 c-2.9-2.53-19.32-6.18-23.48,10.61c-1.14,2.91-1.64,8.33-1.64,8.33c-2.79,0.38-5.3,0-4.3,3.53c0.95,3.35,3.27,2.29,3.53,2.17 c-0.73,1.53,0.91,5.55,5.32,4.03c-0.64,2.39,0.98,2.77,2.19,1.52c-0.18,2.19,2.29,4.84,5.41,2.89c0.13-0.08,0.23-0.15,0.35-0.24 c0.05,0.24,0.09,0.45,0.15,0.66c0.53,1.87,1.76,2.35,2.76,1.76c0.23-0.12,0.44-0.3,0.62-0.53c-0.01,0.26,0,0.55,0.03,0.82 c0.23,2.11,1.75,4.32,4.64,3.09c0.64-0.38,1.89-1.14,1.89-1.14s0.5,1.02,1.23,2.55c0.17,0.35,0.33,0.71,0.52,1.11 c0.16,0.35,0.33,0.72,0.5,1.1c0,0.01,0.01,0.01,0.01,0.02c1.61,3.55,3.57,8.2,3.94,10.5c0.52,3.39,1.41,6.87-0.47,9.54l-0.01,0.01 c-0.13,0.78-0.3,1.56-0.52,2.35c6.38,6.12,24.298,4.843,37.11,2.8c0-6.6,1.99-13.33,5.24-18.91c0.08-0.16,0.17-0.31,0.26-0.46 c0.44-0.74,0.99-1.54,1.58-2.38c0.29-0.42,0.59-0.85,0.91-1.29c0-0.01,0-0.01,0-0.01c0.15-0.22,0.31-0.43,0.45-0.65 c2.113-3.067,4.283-6.658,4.55-10.738c0.003,0.002,0.008,0.006,0.011,0.008c3.334,3.697,5.743-0.667,6.698-1.03 c2.076,1.697,3.121-0.576,3.228-1.515c0.091-0.955-1.424-1.712-1.424-2.561C415.871,173.43,418.402,167.808,418.205,164.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M393.989,145.423c-1.712,13.759,4.9,15.526-6.773,25.244 c-12.532,1.288-19.259-15.516-21.002-20.638c0-0.015-0.015-0.03-0.015-0.045c-0.303-0.894-1.333-1.409,3.182-2.288 c4.91-0.894,2.758-13.434,2.758-13.434s6.879-0.803,12.743,0.924c0.379,0.106,0.758,0.227,1.121,0.364 c0.046-0.007-0.289,5.76-0.316,6.133c-0.085,1.199-0.221,2.399-0.094,3.604C385.731,146.56,389.747,145.423,393.989,145.423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3243"
    },
    d: "M419.583,174.623c0,0.849,1.515,1.606,1.424,2.561c-0.106,0.939-1.152,3.212-3.228,1.515 c-0.955,0.364-3.364,4.728-6.698,1.03c-1.152-0.727-3.44-2.697-4.743-3.879c-0.546-0.5-0.909-0.864-0.97-0.939 c-0.182-0.288-1.697-4.167-1.697-4.167c0-0.015-0.667-2.288-0.667-2.94c0-0.667-5.319-20.214-3.607-23.32 c0,0,8.031-7.334,15.91,7.379c4.182,6.561,6.516,9.652,6.698,13.062C422.204,168.334,419.673,173.956,419.583,174.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#F3D3B5"
    },
    d: "M386.004,140.241c0,0-11.94,2.667-16.547,14.319c-2.152-1.546-2.273-2.819-3.243-4.531 c0-0.015-0.015-0.03-0.015-0.045c-0.303-0.894-1.333-1.409,3.182-2.288c4.91-0.894,3.477-11.605,3.477-11.605 s6.528,0.372,12.392,2.1C385.599,138.494,385.928,139.908,386.004,140.241z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#332D27"
    },
    d: "M345.61,283.704c0.128,0.936,0.256,1.884,0.385,2.82l7.473-1.692l-4.166-42.338 c-0.013,0-0.013,0.013-0.013,0.013c-0.589,1.923-1.102,3.833-1.577,5.704C344.725,260.106,344.02,271.553,345.61,283.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA331B"
    },
    d: "M300.667,258.542c0,0,30.015,25.997,30.509,26.272c0,0,0.013-0.001,0.052,0.009 c1.142,0.167,18.077-2.85,18.077-2.85s-0.931-18.386-0.775-32.849c-0.227-6.986-2.069-9.727-3.059-10.701l-0.027-0.024 c-0.275-0.264-0.49-0.404-0.556-0.438l-0.04-0.023c0,0-0.014-0.012-0.04-0.023c-0.382-0.334-3.449-2.941-7.453-6.32 c-6.402-5.401-15.196-12.748-19.112-15.76c-5.051-1.754-10,2.601-12.077,5.143c-2.06,2.978-3.374,10.942-4.194,18.782 C300.953,249.247,300.667,258.542,300.667,258.542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#AA331B"
    },
    d: "M300.667,258.542c0,0,30.015,25.997,30.509,26.272c0,0,0.013-0.001,0.052,0.009 c1.142,0.167,18.077-2.85,18.077-2.85s-0.266-5.288-0.491-12.429c-0.197-6.166-0.359-13.709-0.284-20.42 c-0.227-6.986-2.069-9.727-3.059-10.701l-0.027-0.024c-0.275-0.264-0.49-0.404-0.556-0.438l-0.04-0.023 c0,0-0.014-0.012-0.04-0.023c-0.027-0.024-0.082-0.072-0.149-0.118c-0.068-0.06-0.15-0.131-0.246-0.215 c-0.287-0.25-0.736-0.631-1.294-1.095c-0.137-0.132-0.287-0.251-0.45-0.381c-0.86-0.752-1.962-1.666-3.203-2.726 c-0.573-0.488-1.185-0.999-1.825-1.534l-0.287-0.25c-3.76-3.177-8.348-7.017-12.292-10.259l-0.001-0.013 c-1.958-1.603-3.753-3.075-5.205-4.223c-0.286-0.238-0.557-0.451-0.828-0.651c-0.285-0.225-0.543-0.426-0.787-0.615 c-5.051-1.754-10,2.601-12.077,5.143c-0.351,0.512-0.68,1.163-0.988,1.929c-0.088,0.224-0.175,0.449-0.262,0.686 c-0.27,0.763-0.52,1.628-0.765,2.57c-0.052,0.183-0.09,0.379-0.141,0.575c-0.363,1.476-0.688,3.13-0.969,4.883 c-0.109,0.676-0.216,1.376-0.323,2.077c-0.091,0.558-0.168,1.129-0.244,1.712c-0.046,0.466-0.116,0.946-0.175,1.412 c-0.033,0.272-0.066,0.544-0.099,0.816c0.003,0.038-0.008,0.065-0.006,0.103c-0.083,0.674-0.153,1.347-0.224,2.019 c-0.607,5.668-0.961,11.28-1.131,14.863C300.72,257.035,300.667,258.542,300.667,258.542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#283819",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M345.443,238.399 c-0.275-0.264-0.49-0.404-0.556-0.438L345.443,238.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA331B"
    },
    d: "M331.176,284.814c0,0,0.013-0.001,0.052,0.009c1.142,0.167,18.077-2.85,18.077-2.85 s-0.931-18.386-0.775-32.849c-0.227-6.986-2.069-9.727-3.059-10.701l-0.027-0.024c-0.275-0.264-0.49-0.404-0.556-0.438 l-0.04-0.023c0,0-0.014-0.012-0.04-0.023c-0.382-0.334-3.449-2.941-7.453-6.32c-1.885,5.394-4.631,25.454-4.631,25.454 C332.563,257.729,331.176,284.814,331.176,284.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#AA331B"
    },
    d: "M331.176,284.814c0,0,0.013-0.001,0.052,0.009c1.142,0.167,18.077-2.85,18.077-2.85 s-0.266-5.288-0.491-12.429c-0.197-6.166-0.359-13.709-0.284-20.42c-0.227-6.986-2.069-9.727-3.059-10.701l-0.027-0.024 c-0.275-0.264-0.49-0.404-0.556-0.438l-0.04-0.023c0,0-0.014-0.012-0.04-0.023c-0.027-0.024-0.082-0.072-0.149-0.118 c-0.068-0.06-0.15-0.131-0.246-0.215c-0.287-0.25-0.736-0.631-1.294-1.095c-0.137-0.132-0.287-0.251-0.45-0.381 c-0.86-0.752-1.962-1.666-3.203-2.726c-0.573-0.488-1.185-0.999-1.825-1.534l-0.287-0.25c-1.56,4.486-3.734,19.137-4.412,23.936 c-0.016,0.142-0.045,0.286-0.061,0.428c0.001,0.013,0.001,0.013,0.002,0.026c-0.017,0.13-0.047,0.26-0.064,0.39 c-0.036,0.234-0.059,0.454-0.096,0.674c0.001,0.013-0.01,0.039-0.009,0.052c-0.01,0.039-0.019,0.091-0.017,0.129 c-0.074,0.814-0.275,4.117-0.49,8.165C331.755,273.585,331.176,284.814,331.176,284.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA331B"
    },
    d: "M303.614,241.077l17.521,14.069l5.405,4.338c2.255,1.814,5.626,0.559,6.156-2.252 c-0.003-0.038,0.007-0.09,0.017-0.129c-0.001-0.013,0.01-0.039,0.009-0.052c0.037-0.221,0.06-0.441,0.096-0.674 c0.017-0.13,0.047-0.26,0.064-0.39c-0.001-0.013-0.001-0.013-0.002-0.026c0.016-0.142,0.045-0.286,0.061-0.428 c0.376-2.428,0.833-5.182,1.353-7.941c3.302-12.389,9.891-9.929,10.512-9.676c-0.027-0.024-0.082-0.072-0.149-0.118 c-0.068-0.06-0.15-0.131-0.246-0.215c-0.287-0.25-0.736-0.631-1.294-1.095c-0.137-0.132-0.287-0.251-0.45-0.381 c-0.86-0.752-1.962-1.666-3.203-2.726c-0.573-0.488-1.185-0.999-1.825-1.534l-0.287-0.25c-3.76-3.177-8.348-7.017-12.292-10.259 l-0.001-0.013c-1.958-1.603-3.753-3.075-5.205-4.223c-0.286-0.238-0.557-0.451-0.828-0.651c-0.285-0.225-0.543-0.426-0.787-0.615 c-5.051-1.754-10,2.601-12.077,5.143c-0.351,0.512-0.68,1.163-0.988,1.929c-0.088,0.224-0.175,0.449-0.262,0.686 c-0.27,0.763-0.52,1.628-0.765,2.57c-0.052,0.183-0.09,0.379-0.141,0.575c-0.363,1.476-0.688,3.13-0.969,4.883 c-0.109,0.676-0.216,1.376-0.323,2.077c-0.091,0.558-0.168,1.129-0.244,1.712c-0.046,0.466-0.116,0.946-0.175,1.412 c-0.033,0.272-0.066,0.544-0.099,0.816c0.003,0.038-0.008,0.065-0.006,0.103C302.087,239.008,302.609,240.271,303.614,241.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA331B"
    },
    d: "M312.311,251.35l3.333,2.453c0.79,0.581,1.902,0.413,2.484-0.377l0.689-0.935 c0.582-0.79,0.413-1.901-0.377-2.482l-3.335-2.454c-0.79-0.581-1.902-0.412-2.483,0.378l-0.688,0.935 C311.352,249.657,311.521,250.769,312.311,251.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA331B"
    },
    d: "M312.311,251.35l3.333,2.453c0.79,0.581,1.902,0.413,2.484-0.377l0.689-0.935 c0.582-0.79,0.413-1.901-0.377-2.482l-3.335-2.454c-0.79-0.581-1.902-0.412-2.483,0.378l-0.688,0.935 C311.352,249.657,311.521,250.769,312.311,251.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#AA331B"
    },
    d: "M300.667,258.542c0,0,30.015,25.997,30.509,26.272c0,0,0.013-0.001,0.052,0.009 c1.142,0.167,18.077-2.85,18.077-2.85s-0.266-5.288-0.491-12.429c-0.197-6.166-0.359-13.709-0.284-20.42 c-0.227-6.986-2.069-9.727-3.059-10.701l-0.027-0.024c-0.275-0.264-0.49-0.404-0.556-0.438l-0.04-0.023 c0,0-0.014-0.012-0.04-0.023c-0.027-0.024-0.082-0.072-0.149-0.118c-0.068-0.06-0.15-0.131-0.246-0.215 c-0.287-0.25-0.736-0.631-1.294-1.095c-0.137-0.132-0.287-0.251-0.45-0.381c-0.86-0.752-1.962-1.666-3.203-2.726 c-0.573-0.488-1.185-0.999-1.825-1.534l-0.287-0.25c0,0-13.387,1.519-16.219,23.55c-0.79,4.485-9.069,11.647-20.295-0.521 C300.72,257.035,300.667,258.542,300.667,258.542z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fill: "#AA331B"
    },
    points: "341.356,249.813 342.066,283.23 340.377,283.513  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M352.659,236.047c-1.48-3.043-4.834-4.676-6.26-7.765c-0.978-2.118-0.874-4.774-2.026-6.75 c-0.851-6.363-2.865-20.257-4.454-22.195c2.475-5.051,15.86-19.446,15.86-19.446l-17.173-10.326c0,0-14.08,21.943-14.585,25.984 c-0.505,4.041,10.906,31.888,10.906,31.888l0.112-0.031c0.009,0.044,0.016,0.089,0.025,0.133c0.6,2.875,1.655,5.506,2.626,8.256 c0.867,2.456,1.089,5.151,2.06,7.633c1.308,3.346,4.509,9.762,5.601,9.714c1.392-0.062-1.446-7.491-1.446-7.491 s3.86,9.334,5.399,8.741c1.074-0.414-2.432-8.957-2.432-8.957s4.121,10.007,5.291,8.949c0.585-0.529-1.037-5.174-2.011-7.787 c0.352,0.861,0.797,1.86,1.229,2.574c0.838,1.387,2.506,3.829,3.094,2.612c0.647-1.339-4.199-9.975-3.033-10.26 c1.166-0.284,1.781,1.854,2.469,2.872c0.483,0.715,1.125,1.26,1.548,0.571c0.392-0.638,0.131-1.825-0.152-2.706 C354.617,240.112,353.637,238.058,352.659,236.047z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M355.308,242.259c-0.69-2.147-1.671-4.201-2.649-6.212c-1.48-3.043-4.834-4.676-6.26-7.765 c-0.82-1.777-1.197-4.86-2.108-7.361c-0.893-6.601-2.832-19.706-4.372-21.584c1.969-4.018,10.837-13.944,14.383-17.837h-2.295 c-3.546,3.893-12.414,13.819-14.383,17.837c1.345,1.64,2.994,11.848,3.985,18.805c-0.001,0.67,0.163,1.775,0.422,3.043 c0.287,2.129,0.994,4.008,0.994,4.008c0.362,1.244,0.744,2.362,1.079,3.089c1.426,3.09,4.78,4.722,6.26,7.765 c0.978,2.011,1.958,4.065,2.649,6.212c0.094,0.293,0.183,0.62,0.25,0.949c0.222,0.433,0.432,0.865,0.649,1.186 c0.483,0.715,1.125,1.26,1.548,0.571C355.852,244.327,355.591,243.141,355.308,242.259z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232937"
    },
    d: "M419.583,174.623c-0.729,0.838-1.436,1.405-2.103,1.755c1.31-5.069-2.753-7.84-2.753-7.84 c1.997,2.923,2.107,5.515,2.22,8.077c-1.936,0.693-3.44-0.563-3.909-2.779c-0.636-3.061-7.849-11.349-8.304-11.865 c0.045,0.561,0.879,7.576,1.606,13.88c1.303,1.182,3.591,3.152,4.743,3.879c3.334,3.697,5.743-0.667,6.698-1.03 c2.076,1.697,3.121-0.576,3.228-1.515C421.098,176.229,419.583,175.471,419.583,174.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3243"
    },
    d: "M406.52,190.46c-0.14,0.22-0.3,0.43-0.45,0.65c0,0,0,0,0,0.01c-0.32,0.44-0.62,0.87-0.91,1.29 c-0.59,0.84-1.14,1.64-1.58,2.38c-0.09,0.15-0.18,0.3-0.26,0.46c-3.25,5.58-5.24,12.31-5.24,18.91 c-12.813,2.043-30.73,3.32-37.11-2.8c0.22-0.79,0.39-1.57,0.52-2.35l0.01-0.01c1.88-2.67,0.99-6.15,0.47-9.54 c-0.37-2.3-2.33-6.95-3.94-10.5c0-0.01-0.01-0.01-0.01-0.02c-0.17-0.38-0.34-0.75-0.5-1.1c-0.19-0.4-0.35-0.76-0.52-1.11 c-0.73-1.53-1.23-2.55-1.23-2.55s-1.25,0.76-1.89,1.14c-2.89,1.23-4.41-0.98-4.64-3.09c-0.03-0.27-0.04-0.56-0.03-0.82 c-0.18,0.23-0.39,0.41-0.62,0.53c-1,0.59-2.23,0.11-2.76-1.76c-0.06-0.21-0.1-0.42-0.15-0.66c-0.12,0.09-0.22,0.16-0.35,0.24 c-3.12,1.95-5.59-0.7-5.41-2.89c-1.21,1.25-2.83,0.87-2.19-1.52c-4.41,1.52-6.05-2.5-5.32-4.03c-0.26,0.12-2.58,1.18-3.53-2.17 c-1-3.53,1.51-3.15,4.3-3.53c0,0,0.5-5.42,1.64-8.33c4.16-16.79,20.58-13.14,23.48-10.61c0.61,0.53,1.29,0.91,1.97,1.2 c0.6,0.25,1.21,0.42,1.79,0.54c0.25,0.05,0.49,0.1,0.72,0.13c0.32,0.04,0.63,0.07,0.92,0.09c1.2,0.06,2.04-0.06,2.04-0.06 s0,0,0.08-0.02c0.33-0.05,0.68-0.14,1-0.24c0.05-0.02,0.89-0.26,0.94-0.26c0.02,0.02,0.02,0.03,0.02,0.05 c0.06,0.12,0.1,0.22,0.15,0.33c0.36,0.94,0.57,1.92,0.69,2.91c0.16,1.1,0.49,2.15,0.84,3.21c0.029,0.089,0.058,0.178,0.088,0.266 c4.744,14.152,26.089,8.216,22.897-6.365c-0.393-1.793-0.785-2.951-0.785-2.951l4.39-0.21l1.2-0.29l2.15-0.53 c0,0,4.54,14.13,5.12,16.4c0.43,1.67,2.06,4.05,3.92,8.48c0.16,0.38,0.31,0.77,0.46,1.16c0.07,0.17,0.13,0.35,0.2,0.52 c0.41,1.03,0.82,2.16,1.21,3.41c0.07,0.21,0.14,0.42,0.21,0.64C412.4,181.13,409.4,186.28,406.52,190.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232937"
    },
    d: "M369.457,154.56c-2.015,0.242-7.879,0.803-8.167-0.879c-1-1.5-22.805-8.804-22.002,13.077 c0.167,1.364,0.53,3.349,1.273,5.47c0.394-6.001,5.485-8.501,5.804-8.637c-3.425,3.531-4.273,7.046-5.046,10.531 c0.909,2,2.182,4,4.016,5.637c-3.121,1.955-5.591-0.697-5.41-2.894c-1.212,1.258-2.833,0.879-2.197-1.515 c-4.409,1.515-6.046-2.5-5.319-4.031c-0.258,0.121-2.576,1.182-3.53-2.167c-1-3.53,1.515-3.152,4.303-3.53 c0,0,0.5-5.425,1.637-8.334c4.167-16.789,20.577-13.138,23.487-10.607c0.606,0.53,1.288,0.909,1.97,1.197 c1.197,0.5,2.44,0.697,3.425,0.758c1.197,0.061,2.046-0.06,2.046-0.06s0,0,0.076-0.015c0.333-0.046,0.682-0.137,1-0.243 c0.046-0.015,0.894-0.258,0.939-0.258c0.015,0.015,0.015,0.03,0.015,0.046c0.06,0.121,0.106,0.227,0.151,0.333 c0.364,0.939,0.576,1.925,0.697,2.909C368.775,152.454,369.109,153.5,369.457,154.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA331B"
    },
    d: "M353.07,237.02c0.01-0.02,0.01-0.04,0.02-0.06c0.02,0.06,0.04,0.11,0.06,0.17L353.07,237.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA331B"
    },
    d: "M364.82,180.44c-0.88,1.71-1.74,3.79-2.53,6.12c-3.22,9.38-5.59,22.54-6.18,29.22 c-0.01,0.03-0.01,0.04,0,0.07c-0.28,8.32-1.49,15.35-3.02,21.11c-0.48-1.28-1.22-2.45-2.15-3.46c-0.34-0.37-1.2-0.89-1.29-1.35 c-0.06-0.35,0.14-0.92,0.2-1.27c0.64-4.11,1.31-8.22,2-12.32c0.8-4.73,1.63-9.45,2.55-14.16c0.84-4.35,1.74-8.69,2.81-12.98 c0.75-2.96,1.5-6.03,2.81-8.8c0.04-0.09,0.07-0.16,0.11-0.24c7.06-14.79,7.99-28.87,7.77-35.04c0.01-0.02,0.019,0.685,0.019,0.675 c0.02-0.26,1.661-1.156,2.581-0.746C370.81,157.039,369.08,172.29,364.82,180.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#3D352E"
    },
    d: "M363.023,174.903c0,0-3.645,9.26-11.169,10.038 C355.798,186.815,359.175,189.122,363.023,174.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232937"
    },
    d: "M406.762,190.195c0,0-8.201,8.34-14.245,0.957C394.474,198.526,400.678,200.046,406.762,190.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232937"
    },
    d: "M384.126,190.195c0,0-8.201,8.34-14.245,0.957C371.838,198.526,378.041,200.046,384.126,190.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#232937"
    },
    d: "M356.327,168.364c0,0,0.815,8.313-8.08,10.941C351.322,176.414,354.728,173.967,356.327,168.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M400.165,119.497c-0.052,0.453-0.105,0.906-0.184,1.359c-1.313,8.484-6.145,17.216-20.353,17.449 c-0.735-0.028-1.497-0.11-2.285-0.261c-7.091-1.304-15.494-7.4-17.858-14.607c-3.716-0.233-12.986-8.665-5.611-13.812 c3.25-2.33,5.78,1.12,5.78,1.12s1.559-6.42,1.559-6.421c0.784-3.993,3.552-8.066,6.661-10.824 c2.135-1.894,3.796-4.425,6.463-5.439c1.323-0.503,2.789-1.013,4.204-1.163c0.914-0.097,1.595,0.298,2.433,0.671 c3.828,1.704,7.563,3.741,10.883,6.31c3.497,2.706,7.039,6.396,7.466,11.023C399.325,104.903,401.045,111.905,400.165,119.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#F3D3B5"
    },
    d: "M356.836,112.878c0,0-0.062,5.232,0.625,6.71c-2.437-1.522-3.402-3.952-3.187-5.272 C354.524,112.78,356.336,112.503,356.836,112.878z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D1D19"
    },
    d: "M392.286,114.984c0.015,1.352,0.631,2.197,1.379,2.189c0.748-0.008,1.345-0.867,1.33-2.219 c-0.015-1.352-0.629-2.072-1.378-2.064C392.87,112.898,392.271,113.632,392.286,114.984z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D1D19"
    },
    d: "M372.731,110.581c1.279-2.339,3.883-2.561,6.06-1.331c0.412,0.233,0.659-0.315,0.254-0.544 c-2.48-1.402-5.528-1.122-6.993,1.558C371.862,110.61,372.54,110.93,372.731,110.581L372.731,110.581z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D1D19"
    },
    d: "M392.117,109.079c1.299-1.329,3.083-1.053,4.342,0.194c0.285,0.282,0.909,0.034,0.562-0.31 c-1.545-1.53-3.84-2.025-5.492-0.334C391.237,108.928,391.849,109.353,392.117,109.079L392.117,109.079z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D1D19"
    },
    d: "M375.654,114.187c0.015,1.383,0.646,2.248,1.411,2.24c0.766-0.009,1.377-0.887,1.361-2.27 c-0.015-1.383-0.644-2.121-1.41-2.112C376.251,112.053,375.639,112.804,375.654,114.187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F4EB"
    },
    d: "M384.631,132.456c-2.341-0.111-5.608-3.306-4.457-5.711c0.11-0.229,0.258-0.452,0.48-0.575 c0.269-0.149,0.596-0.126,0.902-0.098c1.177,0.105,2.358,0.232,3.538,0.289c3.182,0.151,5.146-0.087,5.081,1.279 C390.11,129.005,387.813,132.608,384.631,132.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M376.34,120.29c-0.044,1.173-1.984,2.052-4.333,1.964c-2.349-0.089-4.217-1.112-4.172-2.285 c0.044-1.173,1.984-2.052,4.333-1.964C374.516,118.094,376.384,119.117,376.34,120.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M399.524,120.916c-0.212,1.155-2.258,1.747-4.57,1.322c-2.312-0.425-4.014-1.705-3.802-2.86 c0.212-1.155,2.258-1.747,4.57-1.322C398.034,118.48,399.736,119.761,399.524,120.916z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5AC8A"
    },
    d: "M385.525,113.843c0.275,1.079,0.654,2.01,1.18,2.883c0.269,0.429,0.536,0.86,0.854,1.258 c0.295,0.407,0.646,0.805,0.968,1.157l0.471,0.515l-0.56,0.262c-0.443,0.207-0.909,0.423-1.353,0.651 c-0.219,0.119-0.446,0.233-0.65,0.37c-0.198,0.142-0.421,0.27-0.497,0.528c-0.078-0.274,0.089-0.566,0.237-0.788 c0.159-0.231,0.345-0.432,0.542-0.618c0.395-0.375,0.815-0.696,1.282-0.98l-0.089,0.777c-0.473-0.372-0.835-0.784-1.194-1.23 c-0.332-0.458-0.643-0.939-0.864-1.465c-0.24-0.516-0.384-1.081-0.454-1.643C385.317,114.955,385.38,114.375,385.525,113.843z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA331B"
    },
    d: "M364.951,132.725c5.748,4.4,14.986,7.421,22.246,5.928c9.153-2.404,12.199-10.502,12.821-18.55 c-2.422-1.19-11.598-4.824-27.641-1.066c-3.629,1.184-5.282,1.775-5.282,1.775L364.951,132.725z"
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000024685250469098088430000001065251031771813306_",
    d: "M364.951,132.725 c6.45,4.633,14.986,7.421,22.246,5.928c9.153-2.404,12.199-10.502,12.821-18.55c-2.422-1.19-11.598-4.824-27.641-1.066 c-3.629,1.184-5.282,1.775-5.282,1.775L364.951,132.725z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163067983844386802470000012830087005667525303_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000024685250469098088430000001065251031771813306_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163067983844386802470000012830087005667525303_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M373.536,138.214c3.124,0,3.129-4.855,0-4.855 C370.412,133.359,370.407,138.214,373.536,138.214L373.536,138.214z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163067983844386802470000012830087005667525303_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M388.747,134.351c3.124,0,3.129-4.855,0-4.855 C385.623,129.496,385.618,134.351,388.747,134.351L388.747,134.351z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163067983844386802470000012830087005667525303_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M377.558,120.616c3.124,0,3.129-4.855,0-4.855 C374.434,115.761,374.429,120.616,377.558,120.616L377.558,120.616z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163067983844386802470000012830087005667525303_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M385.709,126.647c3.124,0,3.129-4.855,0-4.855C382.585,121.792,382.58,126.647,385.709,126.647 L385.709,126.647z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163067983844386802470000012830087005667525303_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M396.355,124.892c3.124,0,3.129-4.855,0-4.855 C393.231,120.037,393.225,124.892,396.355,124.892L396.355,124.892z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163067983844386802470000012830087005667525303_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M371.157,126.924c3.124,0,3.129-4.855,0-4.855 C368.033,122.069,368.028,126.924,371.157,126.924L371.157,126.924z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163067983844386802470000012830087005667525303_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M379.657,132.673c3.124,0,3.129-4.855,0-4.855 C376.533,127.818,376.528,132.673,379.657,132.673L379.657,132.673z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163067983844386802470000012830087005667525303_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M384.676,141.318c3.124,0,3.129-4.855,0-4.855 C381.552,136.463,381.547,141.318,384.676,141.318L384.676,141.318z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163067983844386802470000012830087005667525303_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M396.868,134.003c3.124,0,3.129-4.855,0-4.855 C393.744,129.148,393.739,134.003,396.868,134.003L396.868,134.003z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA331B"
    },
    d: "M366.969,123.406c0,0-4.265-5.032-6.719-9.469c-0.585-1.057-1.722-3.864-1.992-4.754 c2.313-0.594,7.44,10.076,12.012,12.426c-2.719,0.906-2.827,0.329-2.827,0.329"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA331B"
    },
    d: "M366.18,129.82l-1.23,2.9c-0.48-0.56-1.74-1.97-2.49-2.79c-1.52-1.67-2.3-3.8-3.39-5.75 c-0.1-0.19-0.21-0.38-0.32-0.57c-0.03-0.05-0.315-0.481,0.144-0.256l2.436,0.305C363.919,128.369,366.18,129.82,366.18,129.82z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M358.258,111.179c1.378-0.404,2.393-0.769,3.051-1.03c0.672-0.248,0.986-0.404,0.986-0.404 c23.613-8.615,20.181-12.437,22.705-20.293c0,0,2.752,3.354,7.793,5.392c5.026,2.012,5.42,10.266,5.42,10.266 c0.058-0.342,0.103-0.669,0.135-1.009c0.024-0.042,0.022-0.069,0.02-0.109c0.758-8.197-6.73-12.879-7.977-14.741 c-0.36-0.53-1.27-1.211-2.385-1.92c-2.793-1.757-10.914,0.209-13.309,2.964C369.053,96.781,361.074,106.261,358.258,111.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E48A29"
    },
    d: "M358.294,111.113c1.37-0.217,2.456-1.079,3.782-1.396c2.404-0.575,4.734-0.594,7.096-1.352 c2.263-0.726,4.807-0.627,7.133-1.274c4.792-1.333,9.251-3.888,12.769-7.412c1.174-1.177,2.673-2.986,4.452-3.181 c1.71-0.188,2.631,1.713,3.443,3.024c1.15,1.856,1.921,3.917,2.685,5.963c-0.42-1.126,0.152-3.422-0.012-4.719 c-0.218-1.73-0.667-3.432-1.326-5.046c-0.84-2.056-2.136-3.87-3.456-5.64c-1.13-1.515-1.952-3.199-3.379-4.47 c-2.727-2.428-6.568-3.488-10.171-3.15c-4.646,0.436-8.905,2.928-12.296,6.133c-1.608,1.52-3.042,3.119-4.651,4.642 c-1.674,1.585-3.203,3.344-4.445,5.29C357.518,102.28,356.286,106.904,358.294,111.113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E48A29"
    },
    d: "M376.006,79.355c0.044,0.098,0.287,0.523,1.072,1.327 C376.723,80.264,376.365,79.822,376.006,79.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#E48A29"
    },
    d: "M376.341,92.062c0,0-3.689,9.704-21.739,14.973 C359.631,103.995,370.005,99.081,376.341,92.062z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#E48A29"
    },
    d: "M386.458,92.197c0,0-2.102,5.529-12.385,8.53 C376.938,98.995,382.848,96.196,386.458,92.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA331B"
    },
    d: "M399.06,214.15c0,0-24.56,6.208-40.46-1.92l0.01-0.01c3.39-4.1,3.39-4.1,3.39-4.1 s10.05,2.58,22.02,2.33c4.7-0.09,9.7-0.63,14.51-1.92C399.06,214.15,399.06,214.15,399.06,214.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B7"
    },
    d: "M612.26,435.514c0.027,0.423,0.081,0.861,0.35,1.147c0.269,0.302,0.699,0.347,1.076,0.362 c4.289,0.257,8.592,0.498,12.881,0.74c-0.054-0.86,1.694-0.694,1.734-0.03c8.955,0.876,18.044,0.815,27.012,0.136 c0.538-0.045,1.17-0.166,1.358-0.725c0.242-1.993-0.766-3.97-2.165-5.224c-1.412-1.253-3.16-1.887-4.894-2.4 c-4.894-1.464-10.151-2.249-14.239-5.616c-0.551-0.453-2.433-0.211-2.904-0.785c-0.699-0.86-1.433-3.57-1.689-4.702 l-1.279-4.918c-5.513,0.498-9.362-1.331-14.875-0.833c-0.309,1.495-0.735,8.019-0.936,9.544 C613.071,426.754,611.883,430.94,612.26,435.514z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3243"
    },
    d: "M610.611,435.487c0.197,0.912,0.648,1.507,1.479,1.537c4.816,0.257,9.647,0.498,14.463,0.74 c-0.06-0.86,1.902-0.694,1.947-0.03c10.055,0.876,20.26,0.815,30.33,0.136c0.604-0.045,1.313-0.166,1.525-0.725 c0.272-1.993-0.861-3.97-2.431-5.224c-1.585-1.253-3.548-1.887-5.495-2.4c-5.495-1.464-11.398-2.249-15.987-5.616 c-0.225-0.165-0.386-0.317-0.548-0.48c-0.677-0.68-1.674-0.896-2.592-0.614c-4.176,1.282-8.607,1.714-12.955,1.301 c-1.134-0.108-2.263-0.273-3.38-0.496c-0.863-0.172-2.193-0.831-3.043-0.762c-1.125,0.091-1.189,1.05-1.54,2.15 C611.985,426.254,609.972,432.535,610.611,435.487z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAF1E6"
    },
    d: "M644.446,427.501c-0.104,1.078-0.902,1.901-1.644,2.641c-1.355,1.351-3.416-0.718-2.097-2.097 c0.734-0.767,1.524-1.548,2.609-1.677C643.883,426.301,644.499,426.944,644.446,427.501L644.446,427.501z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAF1E6"
    },
    d: "M640.016,425.193c0.773,0.852-0.122,2.271-0.607,3.072c-1.096,1.806-3.792-0.19-2.318-1.788 C637.629,425.893,639.15,424.238,640.016,425.193L640.016,425.193z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M660.354,437.145 c0,0-31.772,2.255-49.526-0.999"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B7"
    },
    d: "M584.955,435.514c-0.027,0.423-0.081,0.861-0.349,1.147c-0.269,0.302-0.699,0.347-1.076,0.362 c-4.289,0.257-8.592,0.498-12.881,0.74c0.054-0.86-1.694-0.694-1.734-0.03c-8.955,0.876-18.044,0.815-27.012,0.136 c-0.538-0.045-1.17-0.166-1.358-0.725c-0.242-1.993,0.766-3.97,2.165-5.224c1.412-1.253,3.16-1.887,4.894-2.4 c4.894-1.464,10.151-2.249,14.239-5.616c0.551-0.453,2.433-0.211,2.904-0.785c0.699-0.86,1.433-3.57,1.689-4.702l1.28-4.918 c5.513,0.498,9.362-1.331,14.875-0.833c0.309,1.495,0.735,8.019,0.936,9.544C584.144,426.754,585.331,430.94,584.955,435.514z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3243"
    },
    d: "M586.604,435.487c-0.197,0.912-0.648,1.507-1.479,1.537c-4.816,0.257-9.647,0.498-14.463,0.74 c0.06-0.86-1.902-0.694-1.947-0.03c-10.055,0.876-20.26,0.815-30.33,0.136c-0.604-0.045-1.313-0.166-1.525-0.725 c-0.272-1.993,0.861-3.97,2.431-5.224c1.585-1.253,3.548-1.887,5.495-2.4c5.495-1.464,11.398-2.249,15.987-5.616 c0.225-0.165,0.386-0.317,0.548-0.48c0.677-0.68,1.674-0.896,2.592-0.614c4.176,1.282,8.607,1.714,12.955,1.301 c1.134-0.108,2.263-0.273,3.38-0.496c0.863-0.172,2.193-0.831,3.043-0.762c1.125,0.091,1.189,1.05,1.54,2.15 C585.229,426.254,587.243,432.535,586.604,435.487z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAF1E6"
    },
    d: "M552.769,427.501c0.104,1.078,0.902,1.901,1.644,2.641c1.355,1.351,3.416-0.718,2.097-2.097 c-0.734-0.767-1.524-1.548-2.609-1.677C553.331,426.301,552.715,426.944,552.769,427.501L552.769,427.501z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAF1E6"
    },
    d: "M557.199,425.193c-0.773,0.852,0.122,2.271,0.607,3.072c1.096,1.806,3.793-0.19,2.318-1.788 C559.586,425.893,558.065,424.238,557.199,425.193L557.199,425.193z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M536.86,437.145 c0,0,31.772,2.255,49.526-0.999"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A39D98"
    },
    d: "M562.472,258.081c0.027,0.742,0.594,1.943,4.021,2.78c0.175-1.322,0.459-3.373,0.58-4.25 c-1.956-0.31-3.211-0.243-3.913,0.202c-0.094,0.081-0.203,0.148-0.297,0.256c-0.081,0.081-0.162,0.189-0.216,0.31 C562.539,257.582,562.485,257.811,562.472,258.081c0-0.067-0.014-0.121-0.014-0.189 C562.461,257.946,562.472,258.054,562.472,258.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E283D"
    },
    d: "M642.327,278.353v2.657c-0.106,28.88-8.842,80.492-8.118,133.904c-14.478,2.898-22.333,0-22.333,0 l-9.027-124.658l-16.153,124.658c0,0-1.655,2.567-21.93,0c1.193-70.397-1.229-114.58-0.596-134.086 c0.227-6.899,0.362-25.618,0.362-25.618l27.914,3.909l11.579-9.33c0,0,0.619,0.242,1.812,0.649 c0.075,0.045,0.136,0.061,0.211,0.091c4.801,1.721,17.931,0.555,35.338,5.099C642.126,258.255,642.296,269.853,642.327,278.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3243"
    },
    d: "M652.099,178.611c0,0,9.445,0.41,11.132,9.555c1.2,6.508,9.614,49.493-6.74,48.649 c-9.04-8.546-7.372-10.369-7.372-12.156c0-1.787,0.9-12.055,0.9-12.055L652.099,178.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#3E362E"
    },
    d: "M653.032,182.282c0.473,0,6.32-1.122,8.006,11.358 c1.687,12.48,2.901,39.578-4.003,40.815c-6.904,1.237-4.655-38.455-4.655-38.792S653.032,182.282,653.032,182.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A39D98"
    },
    d: "M580.418,129.385c0,0-0.03-0.191-0.143-0.45c-0.504-1.153-2.653-3.648-11.101,3.423 c-10.345,8.658-15.967,13.83-16.979,15.517s-2.331,3.28-1.232,4.502c1.098,1.223,4.381,1.345,4.718,1.457 c0.337,0.112,2.923,0.112,8.545-2.024c5.622-2.136,9.108-0.562,10.682-3.598S580.418,129.385,580.418,129.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3243"
    },
    d: "M621.091,142.88C621.091,142.88,621.09,142.88,621.091,142.88 c0.016,0.002,23.264,3.243,28.322,22.464c5.022,19.084,1.736,28.863,1.687,29.008c-0.002,0.005,0.001,0.003-0.003,0 c-0.295-0.205-34.97-24.29-35.53-25.186c-0.562-0.9-16.614-12.591-16.614-12.928c0-0.064-8.097-7.002-7.021-8.206 C600.276,138.695,621.078,142.88,621.091,142.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#3E362E"
    },
    d: "M594.28,148.422c13.118-7.709,35.576-0.619,42.468,7.102 c6.892,7.72,8.941,23.088,8.941,23.088s-42.133-7.742-42.487-8.079C602.85,170.195,589.141,151.442,594.28,148.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M550.544,108.822c-0.175,15.018,8.797,40.317,8.797,40.317s5.06-0.027,8.082-1.039 c1.97-0.661,7.651-5.033,10.619-9.094h0.013c1.619-2.226,2.429-4.345,1.363-5.708c-3.022-3.845-8.784-18.08-9.459-21.224 c-0.675-3.144-1.579-32.896-1.916-39.764c-0.419-10.435-12.544-8.06-13.102,1.687C554.093,76.25,550.733,93.791,550.544,108.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A4876"
    },
    d: "M571.337,191.952c0.324,1.619,0.256,5.046-0.04,9.243c-0.175,2.456-0.445,5.168-0.756,7.947v0.054 c-0.04,0.27-0.067,0.513-0.094,0.742c-0.04,0.378-0.094,0.742-0.135,1.12v0.054c-1.012,8.285-2.442,16.61-3.535,19.578 c-2.091,5.64-4.736,18.499-4.358,26.406v0.067c0,0.243,0.013,0.499,0.04,0.729c0,0.054,0.014,0.148,0.014,0.189 c0-0.027,0.013-0.094,0.013-0.108c0.013-0.148,0.04-0.297,0.094-0.418c0.013-0.067,0.04-0.135,0.067-0.175 c0.054-0.121,0.135-0.229,0.216-0.31c0.094-0.108,0.203-0.175,0.297-0.256c0.701-0.445,1.956-0.513,3.913-0.202h0.04 c4.938,0.742,14.357,3.697,30.535,8.487c26.824,7.92,39.129-1.187,43.015-4.223c3.872-3.036,3.306-2.591,1.511-7.758 c-0.04-0.135-0.094-0.27-0.148-0.418c-0.661-1.619-2.199-4.21-4.007-7.354c-0.31-0.553-0.648-1.134-0.971-1.727 c-0.337-0.607-0.675-1.228-1.025-1.862c-0.014-0.013-0.014-0.027-0.027-0.04c-3.872-7.097-7.88-15.841-6.868-22.668 c0.054-0.418,0.135-0.837,0.229-1.241c2.806,0.148,5.33,0.148,7.61,0.054c0.013,0.013,0.027,0,0.054,0 c11.928-0.54,17.123-4.034,20.901-6.126c4.493-2.469,6.746-3.373,6.746-6.962c0-0.108,0-0.243-0.013-0.378 c-0.229-3.468-3.751-7.043-14.613-25.718c-6.585-10.578-13.25-16.502-18.984-19.929c-0.715-0.432-1.39-0.715-2.078-1.066 c-0.945-0.499-1.889-1.039-2.78-1.417c-0.283-0.121-0.567-0.243-0.85-0.364c-1.255-0.499-2.752-1.025-3.67-1.336 c-0.27-0.094-0.54-0.175-0.796-0.256h-0.014c-0.013-0.013-0.013-0.013-0.013-0.013c-0.081-0.027-0.148-0.04-0.216-0.067 c-1.106-0.337-2.024-0.513-2.86-0.796c-2.199-0.729-3.252-2.091-3.711-3.522c-0.054-0.175-0.108-0.351-0.135-0.526 c-0.013-0.027-0.027-0.054-0.027-0.081c-0.162-0.648-0.202-1.309-0.162-1.916c0-0.108,0-0.216,0.013-0.31 c0-0.202,0.027-0.405,0.054-0.58c0.135-1.093,0.432-1.876,0.432-1.876s-0.162,0.054-0.513-0.027 c-0.108-0.027-0.243-0.067-0.391-0.094c-0.607-0.148-1.457-0.337-2.456-0.526c-1.039-0.202-2.24-0.405-3.481-0.54 c-0.054-0.013-0.121-0.013-0.175-0.027c-1.228-0.121-2.483-0.202-3.63-0.148l-0.688,0.041c-0.216,0.013-0.432,0.04-0.648,0.067 c-0.216,0.027-0.418,0.067-0.621,0.108c-0.135,0.027-0.27,0.054-0.405,0.094c-0.054,0.013-0.108,0.027-0.162,0.04 c-0.175,0.041-0.337,0.094-0.486,0.162c-0.162,0.054-0.31,0.122-0.445,0.189c-0.04,0.013-0.081,0.04-0.108,0.067 c-0.135,0.067-0.27,0.148-0.391,0.243c0.013,0.04,0.027,0.081,0.027,0.121c0.013,0.067,0.027,0.121,0.027,0.189 c0.27,1.255,0.229,2.307-0.094,3.117c-0.04,0.148-0.094,0.283-0.148,0.405c-0.013,0.04-0.027,0.081-0.054,0.108 c-0.364,0.742-0.958,1.214-1.754,1.363c-0.041,0-0.094,0.013-0.148,0.013h-0.041c-0.175,0.04-0.378,0.054-0.58,0.04h-0.067 c-0.162-0.013-0.337-0.027-0.513-0.067c-0.378-0.135-0.715-0.31-1.08-0.499c-0.013-0.014-0.04-0.014-0.054-0.027 c-0.04-0.027-0.094-0.054-0.135-0.067c-0.013,0-0.013-0.014-0.027-0.014c-0.607-0.337-1.187-0.702-1.74-1.16 c0,0-0.013-0.014-0.027-0.014c-0.148-0.108-0.297-0.229-0.445-0.351c-0.013,0-0.04-0.027-0.054-0.04 c-0.243-0.202-0.472-0.405-0.702-0.621c-3.967-3.657-7.165-9.809-11.59-17.271c-0.391,1.026-0.904,2.051-1.525,3.049 c0,0.014,0,0.027-0.013,0.041c-0.013,0.013-0.013,0.027-0.027,0.04c-1.228,2.037-2.833,4.008-4.669,5.842 c-0.04,0.041-0.094,0.095-0.135,0.135c-8.19,8.204-20.577,14.046-23.086,13.884c2.699,1.916,14.91,25.434,19.039,35.635 C570.716,189.82,571.175,191.143,571.337,191.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M595.192,153.875c1.066,7.88,5.518,12.575,8.339,13.115c4.547,0.256,8.123-1.471,10.821-3.711 c3.953-3.292,5.991-7.731,6.436-8.757v-0.014c0-0.013,0.013-0.013,0.013-0.027l0.054-0.189c-1.187-0.364-2.213-0.675-3.103-0.971 c-0.405-0.135-0.783-0.297-1.12-0.472c-0.499-0.27-0.918-0.58-1.268-0.918c-0.229-0.216-0.432-0.459-0.607-0.702 s-0.324-0.486-0.445-0.742c-0.189-0.391-0.324-0.783-0.405-1.187c-0.162-0.648-0.202-1.309-0.162-1.916 c0-0.108,0-0.216,0.013-0.31c0-0.202,0.027-0.405,0.054-0.58c0.135-1.093,0.432-1.876,0.432-1.876s-0.189-0.054-0.54-0.135 c-0.108-0.027-0.243-0.068-0.391-0.095c-0.607-0.148-1.457-0.337-2.456-0.526c-0.459-0.094-0.958-0.175-1.471-0.27 c-0.364-0.054-0.729-0.108-1.093-0.162c-0.297-0.04-0.607-0.067-0.918-0.108c-0.094-0.013-0.202-0.027-0.297-0.04 c-0.378-0.04-0.742-0.067-1.12-0.094c-0.067,0-0.148-0.013-0.229-0.013c-0.742-0.04-1.471-0.067-2.159-0.027l-0.688,0.04 c-0.094,0-0.175,0-0.256,0.013c-0.135,0.014-0.256,0.027-0.391,0.054c-0.216,0.027-0.418,0.067-0.621,0.108 c-0.189,0.04-0.378,0.081-0.567,0.135c-0.175,0.04-0.337,0.094-0.486,0.162c-0.162,0.054-0.31,0.121-0.445,0.189 c-0.04,0.013-0.081,0.041-0.108,0.067c-0.135,0.068-0.27,0.149-0.391,0.243c0.013,0.04,0.027,0.081,0.027,0.121 c0.027,0.094,0.041,0.203,0.054,0.297c0.243,1.201,0.189,2.226-0.121,3.009c-0.04,0.148-0.094,0.283-0.148,0.405 c-0.014,0.04-0.027,0.081-0.054,0.108c-0.364,0.742-0.958,1.214-1.754,1.363c-0.04,0-0.094,0.013-0.148,0.013h-0.041 c-0.175,0.04-0.378,0.054-0.58,0.04h-0.067c-0.162-0.013-0.337-0.027-0.513-0.067c-0.378-0.135-0.715-0.31-1.079-0.499 c-0.014-0.013-0.041-0.013-0.054-0.027c-0.04-0.027-0.094-0.054-0.135-0.067C594.909,150.637,594.99,152.31,595.192,153.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M598.997,144.133c0,0,0.202,0.121,0.567,0.364c0.04,0.027,0.094,0.054,0.135,0.081 c2.402,1.606,10.376,7.61,14.653,18.701c3.953-3.292,5.991-7.731,6.436-8.757v-0.014c0-0.013,0.013-0.013,0.013-0.027 c0.04-0.121,0.067-0.175,0.067-0.175v-0.013h-0.013c-0.081-0.027-0.148-0.04-0.216-0.067c-1.093-0.337-2.051-0.621-2.888-0.904 c-0.405-0.135-0.783-0.297-1.12-0.472c-0.499-0.27-0.918-0.58-1.268-0.918c-0.229-0.216-0.432-0.459-0.607-0.702 s-0.324-0.486-0.445-0.742c-0.094-0.189-0.175-0.378-0.243-0.58c-0.054-0.175-0.108-0.351-0.135-0.526 c-0.013-0.027-0.027-0.054-0.027-0.081c-0.162-0.648-0.202-1.309-0.162-1.916c0-0.108,0-0.216,0.013-0.31 c0-0.202,0.027-0.405,0.054-0.58c0.135-1.093,0.432-1.876,0.432-1.876s-0.189-0.054-0.54-0.135 c-0.108-0.027-0.243-0.068-0.391-0.095c-0.607-0.148-1.457-0.337-2.456-0.526c-0.459-0.094-0.958-0.175-1.471-0.27 c-0.364-0.054-0.729-0.108-1.093-0.162c-0.297-0.04-0.607-0.067-0.918-0.108c-0.094-0.013-0.202-0.027-0.297-0.04 c-0.378-0.04-0.742-0.067-1.12-0.094c-0.067,0-0.148-0.013-0.229-0.013c-0.742-0.04-1.471-0.067-2.159-0.027l-0.688,0.04 c-0.094,0-0.175,0-0.256,0.013c-0.499,0.135-0.971,0.243-1.39,0.364c-0.054,0.013-0.108,0.027-0.162,0.04 c-0.364,0.094-0.675,0.175-0.958,0.243C599.416,144.025,598.997,144.133,598.997,144.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#A2D66F",
      strokeWidth: 0.27,
      strokeMiterlimit: 10
    },
    d: "M573.753,239.038"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#A2D66F",
      strokeWidth: 0.27,
      strokeMiterlimit: 10
    },
    d: "M578.576,241.596"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3243"
    },
    d: "M627.639,137.672c0,0,5.495-0.17,8.35,12.538c0.125,0.555-0.146,1.133-0.643,1.411 c-0.587,0.328-1.092,0.588-1.519,0.793c-0.85,0.408-1.842-0.197-1.845-1.139c-0.012-3.425-0.725-10.433-6.226-11.708 C620.896,137.643,627.639,137.672,627.639,137.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M588.388,110.967c0,0-2.225-4.999-4.767,0.245c-0.07,0.144-0.126,0.297-0.164,0.453 c-0.64,2.605-1.212,7.602,3.485,9.327c4.435,1.628,2.674-4.059,2.35-5.019c-0.034-0.101-0.059-0.204-0.078-0.308L588.388,110.967z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A34F25"
    },
    d: "M586.951,95.396c0,0-1.304,14.035,1.394,16.672c3.373-4.784,4.385-6.977,4.385-6.977 s-0.532-0.447,0-1.891c0.532-1.444,1.068-3.28,0.787-4.405C593.236,97.67,586.951,95.396,586.951,95.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M588.251,113.255c0,0-0.001-2.036-1.781-1.698s-2.417,6.634,1.781,7.309 C589.413,114.93,588.251,113.255,588.251,113.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M595.431,142.735c4.694,2.787,10.642,2.636,16.057,2.205c8.871-0.705,16.794-5.092,19.866-13.815 c3.373,0.89,11.024-1.349,10.12-8.555c-0.27-2.159-1.012-3.684-1.956-4.682c-2.226-2.321-5.627-1.727-7.043,0.634 c-3.373-6.962-3.819-15.517-3.819-15.517s-2.928-3.373-4.048-4.048c-1.12-0.675-6.328,0.904-10.363,0.904 c-2.078,0-6.895-0.283-11.091-0.567c-3.94-0.243-7.327-0.499-7.327-0.499l-4.615,0.621c0,0-0.067,0.229-0.189,0.675 c-0.742,2.739-3.454,13.425-3.818,23.518c-0.027,0.472-0.04,0.943-0.04,1.401c0,5.446,1.476,11.417,5.403,15.464 C593.45,141.386,594.411,142.13,595.431,142.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#ECBB97"
    },
    d: "M621.989,106.447c-0.162,1.255,0.364,2.55,2.955,2.375 c1.687,2.172,4.507,38.199-25.947,35.311c11.752,2.24,27.31,1.322,32.356-13.007c3.373,0.89,11.024-1.349,10.12-8.555 c-0.27-2.159-1.012-3.684-1.956-4.682c-2.226-2.321-5.627-1.727-7.043,0.634c-3.373-6.962-3.819-15.517-3.819-15.517 s-2.928-3.373-4.048-4.048c-1.12-0.675-6.328,0.904-10.363,0.904c-2.078,0-6.895-0.283-11.091-0.567l-12.13,0.796 C591.023,100.092,597.459,112.006,621.989,106.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A34F25"
    },
    d: "M584.6,85.533c0.041,2.941,0.513,5.613,1.565,8.055c1.025,2.402,2.618,4.574,4.857,6.504 c11.226,9.661,29.037,4.979,31.56,3.98c2.955-1.16,2.226-0.823,1.862,0c-0.297,0.675-0.526,1.268-0.675,1.767 c-0.229,0.715,0.459,1.403,1.16,1.147c0.864-0.31,1.889-0.148,2.604,1.646c0.837,2.078,0,17.096,0,17.096l4.939-7.205 c1.417-2.361,4.817-2.955,7.043-0.634c0.175-1.201,2.861-5.316,2.968-16.34c0.054-5.519-1.295-8.744-2.955-10.673 c0-0.013,0-0.013,0-0.013c-1.646-1.903-3.576-2.523-4.696-2.807c1.471-2.361-2.24-1.795-3.481-1.241 c-0.04-0.337-0.094-0.607-0.175-0.823c-0.553-1.714-1.983-0.31-2.186,0.486c-6.301-7.866-16.637-5.276-19.902-3.711 c-7.988,3.603-17.986,1.133-20.685-1.349c-0.459-0.324-0.877-0.526-1.241-0.607C585.005,80.257,584.56,83.415,584.6,85.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#ECBB97"
    },
    d: "M634.571,120.747c-0.434,0.494-0.722,2.145-0.885,2.678 c-0.078,0.254-1.035,4.528-0.702,4.468c1.009-0.184,2.036-0.373,2.949-0.841c2.042-1.045,2.607-3.567,1.301-5.477 c-0.448-0.656-1.887-1.399-2.57-0.914C634.632,120.684,634.601,120.713,634.571,120.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#A34F25"
    },
    d: "M584.6,85.533c0.041,2.941,0.513,5.613,1.565,8.055 c1.025,2.402,2.618,4.574,4.857,6.504c11.226,9.661,29.037,4.979,31.56,3.98c2.955-1.16,2.226-0.823,1.862,0 c-0.297,0.675-0.526,1.268-0.675,1.767c-0.229,0.715,0.459,1.403,1.16,1.147c0.864-0.31,1.889-0.148,2.604,1.646 c0.837,2.078,0,17.096,0,17.096l4.939-7.205c1.417-2.361,4.817-2.955,7.043-0.634c0.175-1.201,2.861-5.316,2.968-16.34 c0.054-5.519-1.295-8.744-2.955-10.673c0.04,0.445,0.796,9.634-13.911,3.926c-2.469,1.794-36.768,9-38.455-13.992 C585.005,80.257,584.56,83.415,584.6,85.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#3E362E"
    },
    d: "M630.004,168.339c0,0-8.019,19.484-2.941,33.354 c-3.355-5.244-4.824-27.768-0.415-35.358C627.76,166.868,629.284,167.675,630.004,168.339z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3243"
    },
    d: "M618.441,197.552c0,0,0,0,6.301,3.036c0.702,0.324,1.471,0.702,2.321,1.106 c-4.547-10.484-1.525-25.367,1.16-34.582c1.444-4.938,2.793-8.244,2.834-8.366c0.445-1.403-1.053-2.793-2.564-3.13 c-0.014-0.013-0.014-0.013-0.014-0.013c-0.877-0.189-1.754-0.04-2.28,0.661c-1.767,2.307-3.144,5.249-4.21,8.501 C617.483,178.446,618.441,197.552,618.441,197.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#ECBB97"
    },
    d: "M564.334,112.91c1.686,3.657,7.731,20.159,9.715,25.583 c1.889-1.876,3.549-3.886,4.804-5.977c-3.117-4.696-8.258-17.487-8.892-20.442c-0.675-3.144-1.579-32.896-1.916-39.764 c0,0-1.929,2.253-5.519,2.928C564.563,86.936,562.31,108.525,564.334,112.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#3E362E"
    },
    d: "M624.742,200.587c0.702,0.324,1.471,0.702,2.321,1.106 c-4.547-10.484-1.525-25.367,1.16-34.582c1.444-4.938,2.793-8.244,2.834-8.366c0.445-1.403-1.053-2.793-2.564-3.13 c0.094,0.094,0.648,0.715,0.459,1.956c-0.081,0.634-0.364,1.43-0.971,2.415c-0.486,0.783-1.336,2.955-2.24,5.977 C623.001,175.072,619.79,191.804,624.742,200.587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#4A4876"
    },
    d: "M614.352,163.28c0,0,3.684,0.432,7.637,1.484c1.255,0.337,2.55,0.729,3.751,1.201 c0.891,0.337,1.727,0.715,2.483,1.147c0.675,0.378,1.282,0.783,1.781,1.228c4.156,3.711,30.71,30.035-3.373,48.251 c0.85,0.81,1.673,1.606,2.469,2.348c0.054-0.418,0.135-0.837,0.229-1.241c2.726,0.135,5.276,0.189,7.637,0.162 c0.013,0.013,0.027,0,0.054,0c11.928-0.54,17.123-4.034,20.901-6.126c4.493-2.469,6.746-3.373,6.746-6.962 c0-0.108,0-0.243-0.013-0.378c-0.229-3.468-3.751-7.043-14.613-25.718c-6.585-10.578-13.25-16.502-18.984-19.929 c0.445-1.403-1.053-2.793-2.564-3.13c-0.014-0.013-0.014-0.013-0.014-0.013c-0.877-0.189-1.754-0.04-2.28,0.661 c-0.283-0.121-0.567-0.243-0.85-0.364c-0.349-0.139-0.717-0.279-1.087-0.417c-0.907-0.345-1.782-0.658-2.583-0.919 c-0.27-0.094-0.54-0.175-0.796-0.256h-0.014l-0.013,0.027C620.694,154.739,618.657,159.69,614.352,163.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#3E362E"
    },
    d: "M598.377,144.093c0.027,0.081,0.041,0.202,0.067,0.364 c0.014-0.04,0.041-0.067,0.081-0.067L598.377,144.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#3E362E"
    },
    d: "M570.284,210.95v0.054c6.045-19.484,16.874-48.287,27.188-61.528 c-0.005-0.009-0.041,0-0.041,0c-0.175,0.04-0.378,0.054-0.58,0.04h-0.067c-0.162-0.013-0.337-0.027-0.513-0.067 c-0.378-0.135-0.715-0.31-1.079-0.499c-0.014-0.013-0.041-0.013-0.054-0.027c-0.04-0.027-0.094-0.054-0.135-0.067 c-0.013,0-0.013-0.013-0.027-0.013l-17.042,27.094c0,0-4.561,14.302-6.666,25.151c-0.175,2.456-0.445,5.168-0.756,7.947v0.054 c-0.04,0.27-0.067,0.513-0.094,0.742C570.379,210.208,570.325,210.572,570.284,210.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3243"
    },
    d: "M568.247,208.359c0.58,0.634,1.295,1.134,2.172,1.471c0.027-0.229,0.054-0.472,0.094-0.742v-0.054 c1.579-10.767,16.893-47.657,24.031-57.291c0.891-1.201,1.646-1.97,2.24-2.226c-0.162-0.013-0.337-0.027-0.513-0.067 c-0.378-0.135-0.715-0.31-1.079-0.499c-0.014-0.013-0.041-0.013-0.054-0.027c-0.04-0.027-0.094-0.054-0.135-0.067 c-0.256-0.148-0.486-0.283-0.729-0.432c-0.351-0.216-0.702-0.472-1.039-0.742c0,0-0.013-0.013-0.027-0.013 c-0.148-0.108-0.297-0.229-0.445-0.351c-0.013,0-0.041-0.027-0.054-0.04c-0.877,1.025-1.93,2.28-3.117,3.778 c-5.411,6.827-13.493,18.647-19.592,36.957c-0.837,2.483-1.633,5.087-2.402,7.812 C566.007,199.737,565.602,205.432,568.247,208.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#3E362E"
    },
    d: "M568.247,208.359c0.58,0.634,1.295,1.134,2.172,1.471 c0.027-0.229,0.054-0.472,0.094-0.742v-0.054c1.781-12.103,20.914-57.237,26.271-59.517c-0.162-0.013-0.337-0.027-0.513-0.067 c-0.391-0.148-0.756-0.324-1.133-0.526c-0.297-0.162-0.58-0.324-0.863-0.499C594.275,148.424,574.143,173.602,568.247,208.359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#4A4876"
    },
    d: "M562.418,257.163c0,0.243,0.013,0.499,0.04,0.729c0,0.054,0.014,0.171,0.014,0.211 c0-0.027,0.013-0.117,0.013-0.13c0.013-0.148,0.04-0.297,0.094-0.418c0.013-0.067,0.04-0.135,0.067-0.175 c0.054-0.121,0.135-0.229,0.216-0.31c0.094-0.108,0.203-0.175,0.297-0.256c0.701-0.445,1.956-0.513,3.913-0.202h0.04 c4.938,0.742,14.357,3.697,30.535,8.487c26.824,7.92,39.129-1.187,43.015-4.223c3.872-3.036,3.306-2.591,1.511-7.758 c-0.04-0.135-0.094-0.27-0.148-0.418c-0.661-1.619-2.199-4.21-4.007-7.354c-0.31-0.553-0.648-1.134-0.971-1.727 c-0.337-0.607-0.675-1.228-1.025-1.862c-1.511-0.135-2.537-0.216-2.537-0.216l-52.663,2.766l33.827,18.742 c-0.702-0.243-22.385-5.762-32.478-8.136C572.565,252.67,564.199,252.738,562.418,257.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#3E362E"
    },
    d: "M574.103,138.574c0.742,0.945,7.853,9.836,15.49,12.481 c1.646,0.567,3.319,0.85,4.952,0.688c0.891-1.201,1.646-1.97,2.24-2.226c-0.162-0.013-0.337-0.027-0.513-0.067 c-0.378-0.135-0.715-0.31-1.079-0.499c-0.014-0.013-0.041-0.013-0.054-0.027c-0.04-0.027-0.094-0.054-0.135-0.067 c-0.243-0.135-0.486-0.283-0.729-0.432c-0.351-0.216-0.702-0.472-1.039-0.742c0,0-0.013-0.013-0.027-0.013 c-0.148-0.108-0.297-0.229-0.445-0.351c-0.013,0-0.041-0.027-0.054-0.04c-0.243-0.203-0.472-0.405-0.702-0.621 c-3.967-3.657-7.165-9.809-11.59-17.271c-0.391,1.025-0.904,2.051-1.525,3.049c0,0.013,0,0.027-0.013,0.04 c-0.04,0.108-0.067,0.202-0.108,0.256C577.544,134.769,575.938,136.739,574.103,138.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB92C"
    },
    d: "M580.822,244.305l35.109,16.853l25.272-52.676l-2.523-1.214c-0.108,0.148-0.216,0.297-0.324,0.459 c0,0-22.951,40.897-55.119,31.533L580.822,244.305z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB92C"
    },
    d: "M573.59,240.837l0.918,0.445l1.714,0.809v0.013l1.714,0.81l1.7,0.823l0.27,0.121 c0,0.014,0,0.014,0,0.014l0.918,0.432l2.415-5.046c32.167,9.364,55.119-31.533,55.119-31.533c0.108-0.162,0.216-0.31,0.324-0.459 l-32.585-15.638l-2.888-1.376l-1.714-0.823l-1.714-0.823l-0.917-0.445L573.59,240.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4EB7A"
    },
    d: "M573.59,240.837l0.918,0.445l1.714,0.809v0.013l1.714,0.81l1.7,0.823l0.27,0.121 c0,0.014,0,0.014,0,0.014l0.918,0.432l2.415-5.046l22.857-47.63l-2.888-1.376l-1.714-0.823l-1.714-0.823l-0.917-0.445 L573.59,240.837z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#EDB92C",
      strokeWidth: 0.54,
      strokeMiterlimit: 10
    },
    x1: 604.912,
    y1: 191.069,
    x2: 579.64,
    y2: 243.74
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#EDB92C",
      strokeWidth: 0.54,
      strokeMiterlimit: 10
    },
    x1: 603.203,
    y1: 190.249,
    x2: 577.93,
    y2: 242.92
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#EDB92C",
      strokeWidth: 0.54,
      strokeMiterlimit: 10
    },
    x1: 601.494,
    y1: 189.429,
    x2: 576.221,
    y2: 242.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#EDB92C",
      strokeWidth: 0.54,
      strokeMiterlimit: 10
    },
    x1: 599.784,
    y1: 188.608,
    x2: 574.512,
    y2: 241.279
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#E69624"
    },
    d: "M580.822,244.305l35.109,16.853l25.272-52.676l-2.523-1.214 c-0.108,0.148-0.216,0.297-0.324,0.459c0,0-22.951,40.897-55.119,31.533L580.822,244.305z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M578.911,229.285c0.081,0.682-0.02,1.373-0.011,2.06c0.046,3.799,3.256,5.663,6.225,7.218 c3.268,1.711,7.042,2.355,10.682,2.648c0.343,0.028,0.687,0.052,1.031,0.072c1.795,1.201,34.407,11.496,50.032,8.015 c2.28-0.499,4.088-1.633,5.505-3.211c8.406-9.229,3.765-33.476,3.765-33.476c-7.826,5.222-19.389,5.141-19.389,5.141 s-3.697,7.718-5.384,11.226c-0.027,0.04-0.041,0.081-0.054,0.108c-0.256-0.054-0.553-0.108-0.891-0.148 c-6.112-0.877-24.732-0.58-28.187-1.174c-3.643-0.621-3.495-1.174-5.559-3.967c-0.013-0.013-0.013-0.027-0.013-0.027 c-2.078-2.807-2.962-5.534-5.04-5.777c-2.078-0.256-1.943,0.61-1.781,2.634c0.189,2.28,3.392,6.461,2.045,6.233 c-1.657-0.28-3.164-2.634-3.896-3.97c-0.835-1.524-1.403-3.177-2.034-4.795c-0.249-0.638-0.533-1.305-1.083-1.713 c-1.29-0.957-2.696,0.553-2.838,1.809c-0.035,0.308,0.281,1.032,0.186,1.254c-0.145,0.336-0.537,0.153-0.896,0.266 c-0.453,0.143-0.852,0.508-1.066,0.928c-0.377,0.738-0.342,1.61-0.299,2.437c-1.186,0.873-1.83,2.426-1.612,3.883 c0.117,0.779,0.458,1.512,0.558,2.294C578.909,229.262,578.91,229.273,578.911,229.285z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M631.367,228.977l5.384,0.256v-11.483C636.751,217.751,633.053,225.469,631.367,228.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M579.648,232.498c0.256,0.823,0.661,1.687,1.268,2.537c2.064,2.914,6.49,5.681,15.922,6.247 c1.795,1.201,34.407,11.496,50.032,8.015c2.28-0.499,4.088-1.633,5.505-3.211c0,0-24.922,5.91-54.903-8.258 C593.465,238.058,587.299,241.323,579.648,232.498z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D1D19"
    },
    d: "M596.319,118.653c-0.362,1.606-1.31,2.456-2.199,2.256c-0.889-0.2-1.382-1.375-1.02-2.981 c0.362-1.606,1.277-2.308,2.166-2.108C596.155,116.02,596.681,117.047,596.319,118.653z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D1D19"
    },
    d: "M622.837,115.193c-1.895-4.453-6.738-5.395-10.852-3.564c-0.886,0.394,0.255,1.544,1.011,1.208 c3.286-1.462,6.894-0.799,8.387,2.71C621.719,116.335,623.245,116.151,622.837,115.193L622.837,115.193z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D1D19"
    },
    d: "M599.724,109.405c-2.424-3.022-6.276-2.783-9.089-0.489c-0.636,0.519,0.586,1.381,1.176,0.9 c2.117-1.727,4.95-2.085,6.789,0.208C599.112,110.663,600.337,110.169,599.724,109.405L599.724,109.405z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D1D19"
    },
    d: "M614.954,121.172c-0.37,1.643-1.341,2.514-2.25,2.309c-0.91-0.205-1.414-1.407-1.044-3.05 c0.37-1.643,1.307-2.362,2.216-2.157C614.786,118.478,615.324,119.529,614.954,121.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F4EB"
    },
    d: "M602.887,137.972c2.562,0.128,6.462-3.004,5.465-5.747c-0.095-0.261-0.233-0.52-0.462-0.678 c-0.277-0.191-0.636-0.2-0.973-0.203c-1.294-0.011-2.594,0.002-3.886-0.063c-3.483-0.174-5.597-0.642-5.672,0.852 C597.285,133.628,599.404,137.798,602.887,137.972z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M613.702,126.262c-0.077,1.283,1.943,2.447,4.512,2.601c2.568,0.153,4.712-0.762,4.789-2.045 c0.077-1.283-1.943-2.447-4.512-2.601C615.923,124.063,613.779,124.979,613.702,126.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECBB97"
    },
    d: "M587.634,126.22c0.108,1.281,2.274,2.144,4.838,1.927c2.564-0.216,4.555-1.43,4.446-2.711 c-0.108-1.281-2.274-2.143-4.838-1.927C589.517,123.726,587.526,124.939,587.634,126.22z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA675A"
    },
    d: "M603.69,119.704c0.087,0.594,0.086,1.228-0.067,1.828c-0.142,0.601-0.362,1.195-0.679,1.728 c-0.299,0.545-0.686,1.034-1.096,1.495c-0.435,0.446-0.872,0.856-1.421,1.21l-0.013-0.782c0.477,0.355,0.903,0.745,1.297,1.189 c0.196,0.221,0.38,0.456,0.531,0.72c0.14,0.254,0.295,0.582,0.188,0.873c-0.048-0.29-0.274-0.46-0.472-0.64 c-0.205-0.176-0.438-0.327-0.662-0.484c-0.457-0.303-0.939-0.592-1.4-0.868l-0.535-0.321l0.521-0.461 c0.395-0.349,0.821-0.746,1.189-1.159c0.39-0.402,0.728-0.845,1.066-1.289c0.332-0.45,0.616-0.927,0.883-1.428 C603.286,120.814,603.479,120.278,603.69,119.704z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A4876"
    },
    d: "M624.746,140.392c-6.12,4.789-15.983,8.116-23.756,6.562 c-9.804-2.524-13.111-11.233-13.826-19.908c2.583-1.302,12.375-5.29,29.556-1.359c3.888,1.249,5.66,1.874,5.66,1.874 L624.746,140.392z"
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000154409268583657519530000010460514930542608039_",
    d: "M624.746,140.392 c-6.87,5.045-15.983,8.116-23.756,6.562c-9.804-2.524-13.111-11.233-13.826-19.908c2.583-1.302,12.375-5.29,29.556-1.359 c3.888,1.249,5.66,1.874,5.66,1.874L624.746,140.392z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178909398970235023580000001286161682436603034_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000154409268583657519530000010460514930542608039_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178909398970235023580000001286161682436603034_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M615.582,146.187c3.124,0,3.129-4.855,0-4.855 C612.458,141.332,612.453,146.187,615.582,146.187L615.582,146.187z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178909398970235023580000001286161682436603034_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M599.291,142.136c3.124,0,3.129-4.855,0-4.855 C596.167,137.281,596.162,142.136,599.291,142.136L599.291,142.136z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178909398970235023580000001286161682436603034_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M611.173,127.239c3.124,0,3.129-4.855,0-4.855 C608.049,122.384,608.044,127.239,611.173,127.239L611.173,127.239z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178909398970235023580000001286161682436603034_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M602.493,133.805c3.124,0,3.129-4.855,0-4.855C599.369,128.95,599.364,133.805,602.493,133.805 L602.493,133.805z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178909398970235023580000001286161682436603034_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M591.096,131.993c3.124,0,3.129-4.855,0-4.855 C587.972,127.138,587.967,131.993,591.096,131.993L591.096,131.993z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178909398970235023580000001286161682436603034_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M618.058,133.993c3.124,0,3.129-4.855,0-4.855 C614.934,129.137,614.929,133.993,618.058,133.993L618.058,133.993z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178909398970235023580000001286161682436603034_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M609.002,140.257c3.124,0,3.129-4.855,0-4.855 C605.878,135.402,605.873,140.257,609.002,140.257L609.002,140.257z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178909398970235023580000001286161682436603034_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M603.687,149.618c3.124,0,3.129-4.855,0-4.855 C600.563,144.763,600.558,149.618,603.687,149.618L603.687,149.618z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178909398970235023580000001286161682436603034_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M590.602,141.822c3.124,0,3.129-4.855,0-4.855 C587.479,136.967,587.473,141.822,590.602,141.822L590.602,141.822z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A4876"
    },
    d: "M622.018,129.493c0,0,5.726-3.624,8.212-7.695c0.678-1.11,1.514-2.062,2.01-2.932 c-2.267-1.183-7.897,6.577-13.228,7.942c2.615,1.609,2.867,1.028,2.867,1.028"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4A4876"
    },
    d: "M624.746,140.392l3.066-2.47c0.375-0.302,0.737-0.621,1.085-0.955l6.136-5.898 c0,0-2.877,0.403-3.68,0.056c-5.415,4.544-7.941,6.147-7.941,6.147L624.746,140.392z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3D3B5"
    },
    d: "M574.242,56.987c0.205-0.182,0.42-0.342,0.651-0.469c0.359-0.197,0.769-0.303,1.119-0.126 c0.475,0.24,0.716,0.953,0.703,1.629c-0.014,0.676-0.231,1.326-0.449,1.953c-0.918,2.635-1.93,5.241-3.275,7.565 c-1.345,2.324-3.045,4.367-5.063,5.583c-4.437,2.674-12.361,1.649-13.746-5.412c-0.482-2.457,0.049-5.196-0.55-7.602 c-0.633-2.544-2.486-4.558-2.358-7.275c0.036-0.758,0.383-1.667,0.965-1.682c0.304-0.008,0.563,0.24,0.793,0.484 c1.451,1.544,2.704,3.397,3.7,5.469c0.389-3.242-1.164-6.217-1.334-9.455c-0.026-0.505-0.01-1.053,0.218-1.48 c0.363-0.677,1.142-0.772,1.682-0.412c0.54,0.36,0.891,1.05,1.197,1.729c1.078,2.385,1.89,4.967,2.698,7.539 c0.017-3.393,0.033-6.785,0.05-10.178c0.005-0.919,0.075-2.003,0.675-2.527c0.53-0.463,1.263-0.229,1.701,0.319 c0.438,0.549,0.65,1.334,0.835,2.096c0.828,3.409,1.402,6.936,1.712,10.52c1.402-3.163,0.577-7.235,1.882-10.463 c0.168-0.415,0.38-0.823,0.688-1.066c1.716-1.355,2.265,4.712,2.356,5.956c0.208,2.84,0,5.73-0.229,8.586 c-0.055,0.681,0.036,1.606,0.558,1.641c0.228,0.015,0.441-0.171,0.624-0.363C572.809,58.747,573.445,57.695,574.242,56.987z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5B592"
    },
    d: "M566.871,61.257c-3.31-0.728-6.717-0.808-9.986,0.181c-0.182,0.055-0.106,0.322,0.078,0.283 c3.32-0.698,6.508-0.935,9.861-0.295C566.934,61.446,566.982,61.281,566.871,61.257L566.871,61.257z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5B592"
    },
    d: "M556.763,62.677c2.408,1.45,2.76,4.63,2.646,7.169c-0.007,0.151,0.238,0.188,0.268,0.036 c0.497-2.535-0.459-6.064-2.776-7.441C556.749,62.352,556.612,62.587,556.763,62.677L556.763,62.677z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5B592"
    },
    d: "M569.556,64.44c-2.696,0.632-5.333,3.006-5.331,5.96c0,0.181,0.267,0.219,0.316,0.043 c0.373-1.344,0.7-2.589,1.639-3.67c0.908-1.046,2.112-1.742,3.436-2.116C569.754,64.617,569.696,64.407,569.556,64.44 L569.556,64.44z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFBD9E"
    },
    d: "M582.048,219.494c0.889,2.811,1.975,6.306,4.287,8.292c0.067,0.057,0.293-0.037,0.224-0.096 c-2.295-1.97-3.383-5.456-4.27-8.26C582.262,219.341,582.021,219.408,582.048,219.494L582.048,219.494z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFBD9E"
    },
    d: "M579.821,223.401c-0.248,1.403,0.967,2.917,1.763,3.994c1.086,1.469,2.403,2.714,3.886,3.774 c0.057,0.041,0.268-0.055,0.227-0.085c-1.211-0.866-2.321-1.85-3.275-2.996c-0.944-1.135-2.643-3.135-2.362-4.727 C580.071,223.297,579.832,223.337,579.821,223.401L579.821,223.401z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFBD9E"
    },
    d: "M579.021,229.917c1.232,2.592,3.631,4.114,6.009,5.545c0.068,0.041,0.29-0.058,0.192-0.117 c-2.359-1.419-4.738-2.923-5.96-5.493C579.223,229.769,578.987,229.845,579.021,229.917L579.021,229.917z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C667A"
    },
    d: "M626.28,268.958c0,0-1.026,10.465,10.172,13.774C632.58,279.091,628.293,276.012,626.28,268.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeMiterlimit: 10
    },
    d: "M602.849,290.256c0,0-4.348-11.442-6.098-14.411"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 567.073,
    y1: 256.61,
    x2: 567.073,
    y2: 257.61
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "2.0007,2.0007"
    },
    points: " 567.073,259.611 567.073,334.638 567.073,410.666  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 567.073,
    y1: 411.667,
    x2: 567.073,
    y2: 412.667
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 640.066,
    y1: 262.624,
    x2: 640.03,
    y2: 263.624
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "1.9775,1.9775"
    },
    points: " 639.958,265.6 638.489,306.333 633.876,368.288 631.466,410.681  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#5C667A",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 631.41,
    y1: 411.668,
    x2: 631.354,
    y2: 412.667
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A34F25"
    },
    d: "M615.416,96.167h19.54c-0.269-3.945-1.144-7.567-2.145-9.914c-3.078-7.217-7.571-5.242-8.715-6.728 c-5.431-8.201-16.249-5.232-17.608-2.735c-3.99-0.917-7.377,0.006-8.945,1.078c-1.568,1.072-3.509,2.896-4.621,2.518 c0.461-1.256,0.139-1.587-0.596-3.206c1.193,2.217-2.05,4.381-2.41,3.375c-1.232-2.893,1.857-2.297,1.857-2.297 s-0.567-2.431-3.862-0.55c-3.296,1.881-4.071,10.318-1.75,14.862c2.321,4.544,7.257,4.017,11.998,2.355 c2.04,1.084,11.641-0.799,16.228-1.802C614.565,93.802,614.937,94.876,615.416,96.167z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E48A29"
    },
    d: "M630,210.5c3.217,0,3.223-5,0-5C626.783,205.5,626.777,210.5,630,210.5L630,210.5z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStubackimg);
export default __webpack_public_path__ + "static/media/stubackimg.f0df075ca93eb32dc3669a7b254857e8.svg";
export { ForwardRef as ReactComponent };